import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Byte: { input: any; output: any; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type AiChatMessage = {
  __typename?: 'AIChatMessage';
  content: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  role: AiChatRole;
  tool_call_id: Maybe<Scalars['String']['output']>;
  tool_calls: Maybe<Scalars['JSON']['output']>;
};

export enum AiChatRole {
  Assistant = 'assistant',
  System = 'system',
  Tool = 'tool',
  User = 'user'
}

export type AiChatThread = {
  __typename?: 'AIChatThread';
  id: Scalars['ID']['output'];
  messages: Array<AiChatMessage>;
  spaceId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type AiEmbedding = {
  __typename?: 'AIEmbedding';
  distance: Scalars['Float']['output'];
  fromBlockId: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
  toBlockId: Scalars['String']['output'];
};

export type AiFeaturePermission = {
  __typename?: 'AIFeaturePermission';
  enabled: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  model: Scalars['String']['output'];
};

export type AiSugesstionInput = {
  promptTokens: Scalars['Int']['input'];
  responseText: Scalars['String']['input'];
  responseTokens: Scalars['Int']['input'];
  spaceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AcceptInvitationInput = {
  id: Scalars['String']['input'];
};

export type AcceptPageInvitationInput = {
  id: Scalars['String']['input'];
};

export type AddAiPromptInput = {
  prompt: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: CustomPromptType;
};

export type AddBlocksInput = {
  blocks: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  urlKey: Scalars['String']['input'];
};

export type AdminSpaceList = {
  __typename?: 'AdminSpaceList';
  activeSubscription: Maybe<SpaceSubscription>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ownerIds: Array<Maybe<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
  usedSpaceTokens: Scalars['Int']['output'];
};

export type AdminSpaceListInput = {
  urlKey: Scalars['String']['input'];
};

export type AdminUser = {
  __typename?: 'AdminUser';
  createdAt: Scalars['String']['output'];
  customerId: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  names: Scalars['String']['output'];
  role: UserRole;
  updatedAt: Scalars['String']['output'];
};

export type AdminUserDeleteInput = {
  deletePosthodData: Scalars['Boolean']['input'];
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUserDetailsInput = {
  email: Scalars['String']['input'];
};

export type AdminUserList = {
  __typename?: 'AdminUserList';
  pageInfo: PageInfo;
  users: Array<AdminUser>;
};

export type AdminUserListInput = {
  createdAtFrom: Scalars['Date']['input'];
  createdAtTo?: InputMaybe<Scalars['Date']['input']>;
  page: Scalars['Int']['input'];
};

export type AdminUserListSharedCountInput = {
  userId: Scalars['String']['input'];
};

export type AdminUsersDeleteInput = {
  users: Array<AdminUserDeleteInput>;
};

export type ApiToken = {
  __typename?: 'ApiToken';
  id: Scalars['String']['output'];
};

export type BillingPortalInput = {
  clientUrl?: InputMaybe<Scalars['String']['input']>;
  sourceUrlKey: Scalars['String']['input'];
};

export type CancelSubscriptionInput = {
  subscriptionId: Scalars['String']['input'];
};

export type ChangeSubscriptionInput = {
  priceId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
};

export type ChatThreadsInput = {
  urlKey: Scalars['String']['input'];
};

export type Collection = {
  __typename?: 'Collection';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type CollectionPropertiesOrderInput = {
  collectionId: Scalars['String']['input'];
  folderViewProperties: Array<Scalars['String']['input']>;
  tagViewProperties: Array<Scalars['String']['input']>;
};

export type CollectionPropertyOrder = {
  __typename?: 'CollectionPropertyOrder';
  collectionId: Scalars['String']['output'];
  folderViewProperties: Array<Scalars['String']['output']>;
  tagViewProperties: Array<Scalars['String']['output']>;
};

export type CollectionsByUrlKeyInput = {
  urlKey: Scalars['String']['input'];
};

export type CopyWorkspaceInput = {
  urlKey: Scalars['String']['input'];
};

export type CreateApiTokenInput = {
  urlKey: Scalars['String']['input'];
};

export type CreatePageInput = {
  title: Scalars['String']['input'];
  urlKey: Scalars['String']['input'];
};

export type CreateSpaceInput = {
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  test?: InputMaybe<CreateSpaceTestInput>;
  title: Scalars['String']['input'];
  useCases?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateSpaceSubscription = {
  __typename?: 'CreateSpaceSubscription';
  space: Maybe<Space>;
};

export type CreateSpaceTestInput = {
  createSubscription: Scalars['Boolean']['input'];
};

export type CreateSubscriptionInput = {
  action: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  sourceUrlKey: Scalars['String']['input'];
};

export type CreateSubscriptionSessionInput = {
  action: Scalars['String']['input'];
  clientUrl?: InputMaybe<Scalars['String']['input']>;
  priceId: Scalars['String']['input'];
  referral?: InputMaybe<Scalars['String']['input']>;
  sourceUrlKey: Scalars['String']['input'];
  spaceUrlKey: Scalars['String']['input'];
  workspaceMembersCount: Scalars['Int']['input'];
};

export type CustomAiPrompt = {
  __typename?: 'CustomAIPrompt';
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  prompt: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: CustomPromptType;
};

export enum CustomPromptType {
  Command = 'COMMAND',
  Prompt = 'PROMPT'
}

export type CustomToken = {
  __typename?: 'CustomToken';
  token: Scalars['String']['output'];
};

export type DeleteAssetInput = {
  assetKeys: Array<Scalars['String']['input']>;
  urlKey: Scalars['String']['input'];
};

export type DeleteSpaceInput = {
  urlKey: Scalars['String']['input'];
};

export type DuplicateAssetKeyInput = {
  assetKey: Scalars['String']['input'];
  assetType: Scalars['String']['input'];
  sourceSpaceUrlKey: Scalars['String']['input'];
  targetSpaceUrlKey: Scalars['String']['input'];
};

export type DuplicatePageAssetsInput = {
  assetKeys: Array<DuplicateAssetKeyInput>;
};

export type EmbeddingSearchInput = {
  query?: InputMaybe<Scalars['String']['input']>;
  urlKey: Scalars['String']['input'];
};

export type ExtendedSettings = {
  __typename?: 'ExtendedSettings';
  collectionPropertiesOrder: Maybe<Array<CollectionPropertyOrder>>;
  collectionsColumnsOrder: Maybe<Array<Scalars['String']['output']>>;
  pagesColumnsOrder: Maybe<Array<Scalars['String']['output']>>;
  sharedPagesColumnsOrder: Maybe<Array<Scalars['String']['output']>>;
  tasksColumnsOrder: Maybe<Array<Scalars['String']['output']>>;
};

export type ExtendedSettingsInput = {
  collectionPropertiesOrder?: InputMaybe<Array<CollectionPropertiesOrderInput>>;
  collectionsColumnsOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  pagesColumnsOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedPagesColumnsOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  tasksColumnsOrder?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FeaturePermission = {
  __typename?: 'FeaturePermission';
  enabled: Scalars['Boolean']['output'];
  limit: Maybe<Scalars['Int']['output']>;
};

export enum FeatureSet {
  Business = 'BUSINESS',
  Free = 'FREE',
  Standard = 'STANDARD'
}

export type FileUploadPermission = {
  __typename?: 'FileUploadPermission';
  limitFile: Scalars['Int']['output'];
};

export type GoogleDriveFile = {
  __typename?: 'GoogleDriveFile';
  iconLink: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mimeType: Maybe<Scalars['String']['output']>;
  modifiedTime: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owners: Maybe<Array<Maybe<GoogleDriveOwner>>>;
  thumbnailLink: Maybe<Scalars['String']['output']>;
  webViewLink: Scalars['String']['output'];
};

export type GoogleDriveFileInput = {
  id: Scalars['String']['input'];
};

export type GoogleDriveOwner = {
  __typename?: 'GoogleDriveOwner';
  displayName: Maybe<Scalars['String']['output']>;
};

export type HideAiThreadInput = {
  threadId: Scalars['String']['input'];
};

export type IntegrationSearchInput = {
  query: Scalars['String']['input'];
};

export type IntegrationSearchResult = {
  __typename?: 'IntegrationSearchResult';
  googleDriveFiles: Array<GoogleDriveFile>;
  linearIssues: Array<LinearIssue>;
};

export type Invite = {
  __typename?: 'Invite';
  id: Scalars['String']['output'];
  role: Role;
  userEmail: Scalars['String']['output'];
};

export type InviteMembersInput = {
  newMembers: Array<NewMemberInput>;
  urlKey: Scalars['String']['input'];
};

export type InviteMetaData = {
  __typename?: 'InviteMetaData';
  inviteId: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
  workspaceMembersCount: Scalars['Int']['output'];
  workspaceOwnerEmail: Scalars['String']['output'];
  workspaceTitle: Scalars['String']['output'];
};

export type InviteMetaDataInput = {
  id: Scalars['String']['input'];
};

export type InvitePageMembersInput = {
  newMembers: Array<NewPageMemberInput>;
  pageId: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
};

export type InvitesInput = {
  urlKey: Scalars['String']['input'];
};

export type Invoices = {
  __typename?: 'Invoices';
  created: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  paid: Scalars['Boolean']['output'];
  pdfUrl: Maybe<Scalars['String']['output']>;
  subscriptionId: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type InvoicesInput = {
  spaceId: Scalars['String']['input'];
};

export enum Language {
  De = 'DE',
  En = 'EN',
  Es = 'ES',
  Fr = 'FR',
  It = 'IT',
  Pt = 'PT'
}

export type LeaveSpaceInput = {
  urlKey: Scalars['String']['input'];
};

export type LinearIssue = {
  __typename?: 'LinearIssue';
  assignee: Maybe<LinearUser>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  priorityLabel: Maybe<Scalars['String']['output']>;
  state: Maybe<LinearIssueState>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  url: Scalars['String']['output'];
};

export type LinearIssueCreateInput = {
  teamId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type LinearIssueDeleteInput = {
  id: Scalars['String']['input'];
};

export type LinearIssueInput = {
  id: Scalars['String']['input'];
};

export type LinearIssueState = {
  __typename?: 'LinearIssueState';
  color: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LinearTeam = {
  __typename?: 'LinearTeam';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LinearUser = {
  __typename?: 'LinearUser';
  name: Scalars['String']['output'];
};

export type MarkNotificationsAsReadInput = {
  ids: Array<Scalars['String']['input']>;
};

export type Member = {
  __typename?: 'Member';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  role: Maybe<Role>;
  spaceId: Scalars['String']['output'];
  userEmail: Maybe<Scalars['String']['output']>;
};

export type MembersInput = {
  urlKey: Scalars['String']['input'];
};

export type MentionNotification = Node & Notification & {
  __typename?: 'MentionNotification';
  blockId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mentionBlockUrl: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
  pageTitle: Scalars['String']['output'];
  readAt: Maybe<Scalars['String']['output']>;
  spaceColor: Maybe<Scalars['String']['output']>;
  spaceId: Scalars['String']['output'];
  spaceTitle: Scalars['String']['output'];
  spaceUrlKey: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation: Space;
  acceptPageInvitation: SharedPage;
  addAIPrompt: CustomAiPrompt;
  addBlocks: Maybe<Scalars['String']['output']>;
  adminUserDelete: Array<UserDelete>;
  adminUserDetails: UserWithDetails;
  cancelSubscription: SpaceSubscription;
  changeSubscription: SpaceSubscription;
  copyWorkspace: Space;
  createApiToken: ApiToken;
  createPage: Page;
  createSpace: Space;
  createSubscription: Maybe<CreateSpaceSubscription>;
  createSubscriptionSession: SubscriptionSession;
  deleteAsset: Scalars['Boolean']['output'];
  deleteSpace: Space;
  duplicatePageAssets: Scalars['Boolean']['output'];
  hideAIThread: Scalars['Boolean']['output'];
  inviteMembers: Array<Invite>;
  invitePageMembers: Array<PageInvite>;
  leaveSpace: Space;
  linearIssueCreate: LinearIssue;
  linearIssueDelete: Scalars['Boolean']['output'];
  markNotificationsAsRead: Array<Notification>;
  removeAIPrompt: Scalars['Boolean']['output'];
  removeMember: Scalars['String']['output'];
  removeSharedPage: Scalars['Boolean']['output'];
  removeUserIntegration: Scalars['Boolean']['output'];
  requestSignInLink: Scalars['Boolean']['output'];
  revokeInvite: Invite;
  revokePageInvite: PageInvite;
  sendNotification: Scalars['Boolean']['output'];
  sendTaskAssignmentNotification: Scalars['Boolean']['output'];
  sendTaskMentionNotification: Scalars['Boolean']['output'];
  sharePage: SharedPage;
  signup: User;
  updateAIPrompts: Maybe<Array<CustomAiPrompt>>;
  updateMemberRole: Member;
  updatePageSharedToSpace: SharedPage;
  updateSpaceMetadata: Space;
  updateSpacePublicMetadata: Space;
  updateSpaceSorting: Array<Space>;
  updateSpaceUseCases: Space;
  updateUserLanguage: User;
  updateUserName: User;
  updateUserPagePermission: Array<PageMember>;
  updateUserSettings: UserSettings;
};


export type MutationAcceptInvitationArgs = {
  input: AcceptInvitationInput;
};


export type MutationAcceptPageInvitationArgs = {
  input: AcceptPageInvitationInput;
};


export type MutationAddAiPromptArgs = {
  input: AddAiPromptInput;
};


export type MutationAddBlocksArgs = {
  input: AddBlocksInput;
};


export type MutationAdminUserDeleteArgs = {
  input: AdminUsersDeleteInput;
};


export type MutationAdminUserDetailsArgs = {
  input: AdminUserDetailsInput;
};


export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationChangeSubscriptionArgs = {
  input: ChangeSubscriptionInput;
};


export type MutationCopyWorkspaceArgs = {
  input: CopyWorkspaceInput;
};


export type MutationCreateApiTokenArgs = {
  input: CreateApiTokenInput;
};


export type MutationCreatePageArgs = {
  input: CreatePageInput;
};


export type MutationCreateSpaceArgs = {
  input: CreateSpaceInput;
};


export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationCreateSubscriptionSessionArgs = {
  input: CreateSubscriptionSessionInput;
};


export type MutationDeleteAssetArgs = {
  input: DeleteAssetInput;
};


export type MutationDeleteSpaceArgs = {
  input: DeleteSpaceInput;
};


export type MutationDuplicatePageAssetsArgs = {
  input: DuplicatePageAssetsInput;
};


export type MutationHideAiThreadArgs = {
  input: HideAiThreadInput;
};


export type MutationInviteMembersArgs = {
  input: InviteMembersInput;
};


export type MutationInvitePageMembersArgs = {
  input: InvitePageMembersInput;
};


export type MutationLeaveSpaceArgs = {
  input: LeaveSpaceInput;
};


export type MutationLinearIssueCreateArgs = {
  input: LinearIssueCreateInput;
};


export type MutationLinearIssueDeleteArgs = {
  input: LinearIssueDeleteInput;
};


export type MutationMarkNotificationsAsReadArgs = {
  input: MarkNotificationsAsReadInput;
};


export type MutationRemoveAiPromptArgs = {
  input: RemoveAiPromptInput;
};


export type MutationRemoveMemberArgs = {
  input: RemoveMemberInput;
};


export type MutationRemoveSharedPageArgs = {
  input: RemoveSharedPageInput;
};


export type MutationRemoveUserIntegrationArgs = {
  input: RemoveUserIntegrationInput;
};


export type MutationRequestSignInLinkArgs = {
  input: RequestSignInLinkInput;
};


export type MutationRevokeInviteArgs = {
  input: RevokeInviteInput;
};


export type MutationRevokePageInviteArgs = {
  input: RevokePageInviteInput;
};


export type MutationSendNotificationArgs = {
  input: SendNotificationInput;
};


export type MutationSendTaskAssignmentNotificationArgs = {
  input: SendTaskAssignmentNotificationInput;
};


export type MutationSendTaskMentionNotificationArgs = {
  input: SendTaskMentionNotificationInput;
};


export type MutationSharePageArgs = {
  input: SharePageInput;
};


export type MutationSignupArgs = {
  input: SignupInput;
};


export type MutationUpdateAiPromptsArgs = {
  input: Array<UpdateAiPromptsInput>;
};


export type MutationUpdateMemberRoleArgs = {
  input: UpdateMemberRoleInput;
};


export type MutationUpdatePageSharedToSpaceArgs = {
  input: UpdatePageSharedToSpaceInput;
};


export type MutationUpdateSpaceMetadataArgs = {
  input: UpdateSpaceMetadataInput;
};


export type MutationUpdateSpacePublicMetadataArgs = {
  input: UpdateSpacePublicMetadataInput;
};


export type MutationUpdateSpaceSortingArgs = {
  input: UpdateSpaceSortingInput;
};


export type MutationUpdateSpaceUseCasesArgs = {
  input: UpdateSpaceUseCasesInput;
};


export type MutationUpdateUserLanguageArgs = {
  input: UpdateUserLanguageInput;
};


export type MutationUpdateUserNameArgs = {
  input: UpdateUserNameInput;
};


export type MutationUpdateUserPagePermissionArgs = {
  input: UpdateUserPagePermissionInput;
};


export type MutationUpdateUserSettingsArgs = {
  input: InputMaybe<UpdateUserSettingsInput>;
};

export type NewMemberInput = {
  email: Scalars['String']['input'];
  role: Role;
};

export type NewPageMemberInput = {
  email: Scalars['String']['input'];
  role: PagePermission;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type Notification = {
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  readAt: Maybe<Scalars['String']['output']>;
  spaceColor: Maybe<Scalars['String']['output']>;
  spaceTitle: Scalars['String']['output'];
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  cursor: Scalars['String']['output'];
  node: Notification;
};

export type NotificationsConnection = {
  __typename?: 'NotificationsConnection';
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
};

export type Page = {
  __typename?: 'Page';
  aliases: Array<Scalars['String']['output']>;
  archivedAt: Maybe<Scalars['String']['output']>;
  collections: Array<Scalars['String']['output']>;
  icon: Maybe<PageIcon>;
  id: Scalars['String']['output'];
  isPublicDuplicatable: Maybe<Scalars['Boolean']['output']>;
  isTemplate: Maybe<Scalars['Boolean']['output']>;
  settings: PageSettings;
  spaceId: Scalars['String']['output'];
  staticBlocks: Scalars['JSON']['output'];
  title: Scalars['String']['output'];
};

export type PageAndPermission = {
  __typename?: 'PageAndPermission';
  page: Page;
  permission: PagePermission;
};

export type PageHistoryInput = {
  pageId: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type PageHistorySnapshot = {
  __typename?: 'PageHistorySnapshot';
  authorEmail: Maybe<Scalars['String']['output']>;
  buffer: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type PageIcon = {
  __typename?: 'PageIcon';
  colons: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Maybe<Scalars['String']['output']>;
};

export type PageInput = {
  pageId: Scalars['String']['input'];
};

export type PageInvite = {
  __typename?: 'PageInvite';
  id: Scalars['String']['output'];
  role: PagePermission;
  userEmail: Scalars['String']['output'];
};

export type PageInviteMeta = {
  __typename?: 'PageInviteMeta';
  id: Scalars['String']['output'];
  inviterEmail: Scalars['String']['output'];
  role: PagePermission;
  title: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
};

export type PageInviteMetaInput = {
  id: Scalars['String']['input'];
};

export type PageInviteNotification = Node & Notification & {
  __typename?: 'PageInviteNotification';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inviteId: Maybe<Scalars['String']['output']>;
  pageId: Scalars['String']['output'];
  pageTitle: Scalars['String']['output'];
  readAt: Maybe<Scalars['String']['output']>;
  spaceColor: Maybe<Scalars['String']['output']>;
  spaceTitle: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type PageInvitesInput = {
  pageId: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
};

export type PageMember = {
  __typename?: 'PageMember';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
  permission: PagePermission;
  userEmail: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type PageMembersInput = {
  pageId: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
};

export enum PagePermission {
  Admin = 'ADMIN',
  Hidden = 'HIDDEN',
  Viewer = 'VIEWER',
  Writer = 'WRITER'
}

export type PageSettings = {
  __typename?: 'PageSettings';
  fullWidth: Maybe<Scalars['Boolean']['output']>;
};

export type PagesByUrlKeyInput = {
  urlKey: Scalars['String']['input'];
};

export type Permissions = {
  __typename?: 'Permissions';
  editors: FeaturePermission;
  fileUpload: FileUploadPermission;
  guests: FeaturePermission;
  sagaAi: AiFeaturePermission;
  tasks: FeaturePermission;
  viewers: FeaturePermission;
};

export type PermissionsUpdatedInput = {
  urlKey: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  adminSpaceList: AdminSpaceList;
  adminUserList: AdminUserList;
  adminUserListSharedCount: UserListSharedCount;
  allSharedPagesStatusesByUrlKey: Array<SharedPage>;
  billingPortal: Scalars['String']['output'];
  cannyToken: Maybe<Scalars['String']['output']>;
  chatThreads: Array<AiChatThread>;
  collectionsByUrlKey: Array<Collection>;
  currentUser: Maybe<User>;
  getCustomToken: CustomToken;
  googleDriveDocument: GoogleDriveFile;
  inviteMetaData: Maybe<InviteMetaData>;
  invites: Array<Invite>;
  invoices: Array<Invoices>;
  linearIssue: LinearIssue;
  linearTeams: Array<LinearTeam>;
  members: Array<Member>;
  notificationsConnection: NotificationsConnection;
  page: Maybe<PageAndPermission>;
  pageHistory: Array<PageHistorySnapshot>;
  pageInviteMetaData: Maybe<PageInviteMeta>;
  pageInvites: Array<PageInvite>;
  pageMembers: Array<PageMember>;
  pagesByUrlKey: Array<Page>;
  searchIntegrations: IntegrationSearchResult;
  sharedPageStatus: Maybe<SharedPage>;
  spaceByUrlKey: Maybe<Space>;
  spaceEmbeddings: Array<AiEmbedding>;
  spacePermissions: SpacePermissions;
  spaces: Array<Space>;
  subscriptionPlans: Array<SubscriptionPlan>;
  subscriptionUpcoming: Maybe<SubscriptionUpcoming>;
  templates: Array<Template>;
  unreadNotificationsCounter: Maybe<Scalars['Int']['output']>;
  userIntegrations: Array<UserIntegration>;
  userInvites: Array<InviteMetaData>;
  userPageInvites: Array<PageInviteMeta>;
  userPagePermissionsBySpaceId: Array<UserPagePermission>;
  userSettings: Maybe<UserSettings>;
  userSharedPages: Array<SharedPageInfo>;
};


export type QueryAdminSpaceListArgs = {
  input: AdminSpaceListInput;
};


export type QueryAdminUserListArgs = {
  input: AdminUserListInput;
};


export type QueryAdminUserListSharedCountArgs = {
  input: AdminUserListSharedCountInput;
};


export type QueryAllSharedPagesStatusesByUrlKeyArgs = {
  input: PagesByUrlKeyInput;
};


export type QueryBillingPortalArgs = {
  input: BillingPortalInput;
};


export type QueryChatThreadsArgs = {
  input: ChatThreadsInput;
};


export type QueryCollectionsByUrlKeyArgs = {
  input: CollectionsByUrlKeyInput;
};


export type QueryGoogleDriveDocumentArgs = {
  input: GoogleDriveFileInput;
};


export type QueryInviteMetaDataArgs = {
  input: InviteMetaDataInput;
};


export type QueryInvitesArgs = {
  input: InvitesInput;
};


export type QueryInvoicesArgs = {
  input: InvoicesInput;
};


export type QueryLinearIssueArgs = {
  input: LinearIssueInput;
};


export type QueryMembersArgs = {
  input: MembersInput;
};


export type QueryNotificationsConnectionArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPageArgs = {
  input: PageInput;
};


export type QueryPageHistoryArgs = {
  input: PageHistoryInput;
};


export type QueryPageInviteMetaDataArgs = {
  input: PageInviteMetaInput;
};


export type QueryPageInvitesArgs = {
  input: PageInvitesInput;
};


export type QueryPageMembersArgs = {
  input: PageMembersInput;
};


export type QueryPagesByUrlKeyArgs = {
  input: PagesByUrlKeyInput;
};


export type QuerySearchIntegrationsArgs = {
  input: IntegrationSearchInput;
};


export type QuerySharedPageStatusArgs = {
  input: PageInput;
};


export type QuerySpaceByUrlKeyArgs = {
  input: SpaceByUrlKeyInput;
};


export type QuerySpaceEmbeddingsArgs = {
  input: EmbeddingSearchInput;
};


export type QuerySpacePermissionsArgs = {
  input: SpaceByUrlKeyInput;
};


export type QuerySubscriptionUpcomingArgs = {
  input: SubscriptionUpcomingInput;
};


export type QueryUserPagePermissionsBySpaceIdArgs = {
  input: UserPagePermissionsBySpaceIdInput;
};

export type RemoveAiPromptInput = {
  id: Scalars['ID']['input'];
};

export type RemoveMemberInput = {
  urlKey: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type RemoveSharedPageInput = {
  pageId: Scalars['String']['input'];
  urlKey: Scalars['String']['input'];
};

export type RemoveUserIntegrationInput = {
  id: Scalars['String']['input'];
};

export type RequestSignInLinkInput = {
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};

export type RevokeInviteInput = {
  id: Scalars['String']['input'];
  urlKey: Scalars['String']['input'];
};

export type RevokePageInviteInput = {
  id: Scalars['String']['input'];
};

export enum Role {
  Member = 'MEMBER',
  Owner = 'OWNER',
  Viewer = 'VIEWER',
  Writer = 'WRITER'
}

export type SendNotificationInput = {
  blockId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
};

export type SendTaskAssignmentNotificationInput = {
  action: TaskAssignAction;
  memberId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
  urlKey: Scalars['String']['input'];
};

export type SendTaskMentionNotificationInput = {
  blockId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type SharePageInput = {
  pageId: Scalars['String']['input'];
  urlKey: Scalars['String']['input'];
};

export type SharedPage = {
  __typename?: 'SharedPage';
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isPrivateInSpace: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  spaceId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type SharedPageInfo = {
  __typename?: 'SharedPageInfo';
  icon: Maybe<PageIcon>;
  page: SharedPage;
  permission: PagePermission;
  sharedBy: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SignupInput = {
  agreedToTerms: Scalars['Boolean']['input'];
  firstName: Scalars['String']['input'];
  language: Language;
  lastName: Scalars['String']['input'];
  optInTracking: Scalars['Boolean']['input'];
};

export type Space = {
  __typename?: 'Space';
  access: SpaceAccess;
  activeSubscription: Maybe<SpaceSubscription>;
  color: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isCopyWorkspaceEnabled: Scalars['Boolean']['output'];
  isEmbeddingEnabled: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  members: Array<Member>;
  owner: Scalars['String']['output'];
  permissions: Permissions;
  subscriptions: Array<Maybe<SpaceSubscription>>;
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
  useCases: Array<Scalars['String']['output']>;
};

export type SpaceAiSuggestion = {
  __typename?: 'SpaceAISuggestion';
  id: Scalars['ID']['output'];
  promptText: Scalars['String']['output'];
  promptTokens: Scalars['Int']['output'];
  responseText: Scalars['String']['output'];
  responseTokens: Scalars['Int']['output'];
  spaceId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type SpaceAccess = {
  __typename?: 'SpaceAccess';
  read: Scalars['Boolean']['output'];
  write: Scalars['Boolean']['output'];
};

export type SpaceByUrlKeyInput = {
  urlKey: Scalars['String']['input'];
};

export type SpacePermissions = {
  __typename?: 'SpacePermissions';
  sagaAiStatus: Scalars['String']['output'];
};

export type SpaceSubscription = {
  __typename?: 'SpaceSubscription';
  canceled: Scalars['Boolean']['output'];
  currentPeriodEnd: Scalars['Date']['output'];
  currentPeriodStart: Scalars['Date']['output'];
  customerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  plan: SpaceSubscriptionPlan;
  planId: Scalars['String']['output'];
  price: SubscriptionPlanPrice;
  priceId: Scalars['String']['output'];
  spaceId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
};

export type SpaceSubscriptionPlan = {
  __typename?: 'SpaceSubscriptionPlan';
  featureSet: FeatureSet;
  id: Scalars['ID']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  permissionsUpdated: SpacePermissions;
  unreadNotificationsCounterUpdated: Scalars['Int']['output'];
  userPagePermissionsBySpaceId: Array<UserPagePermission>;
  userSharedPages: Maybe<Array<SharedPageInfo>>;
};


export type SubscriptionPermissionsUpdatedArgs = {
  input: PermissionsUpdatedInput;
};


export type SubscriptionUserPagePermissionsBySpaceIdArgs = {
  input: UserPagePermissionsBySpaceIdInput;
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  featureSet: FeatureSet;
  id: Scalars['String']['output'];
  price: Array<SubscriptionPlanPrice>;
  stripeId: Scalars['String']['output'];
};

export type SubscriptionPlanPrice = {
  __typename?: 'SubscriptionPlanPrice';
  amount: Scalars['Int']['output'];
  amountDecimal: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  interval: SubscriptionPriceInterval;
  lookupKey: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stripeId: Scalars['String']['output'];
};

export enum SubscriptionPriceInterval {
  Month = 'month',
  Year = 'year'
}

export type SubscriptionSession = {
  __typename?: 'SubscriptionSession';
  session: Maybe<Scalars['String']['output']>;
};

export type SubscriptionUpcoming = {
  __typename?: 'SubscriptionUpcoming';
  created: Scalars['Date']['output'];
  paid: Scalars['Boolean']['output'];
  periodEnd: Scalars['Date']['output'];
  periodStart: Scalars['Date']['output'];
  total: Scalars['Int']['output'];
};

export type SubscriptionUpcomingInput = {
  priceId?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['String']['input'];
};

export enum TaskAssignAction {
  Assign = 'ASSIGN',
  Unassign = 'UNASSIGN'
}

export type TaskAssignmentNotification = Node & Notification & {
  __typename?: 'TaskAssignmentNotification';
  action: TaskAssignAction;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  readAt: Maybe<Scalars['String']['output']>;
  spaceColor: Maybe<Scalars['String']['output']>;
  spaceId: Scalars['String']['output'];
  spaceTitle: Scalars['String']['output'];
  spaceUrlKey: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  taskTitle: Scalars['String']['output'];
  taskUrl: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type TaskMentionNotification = Node & Notification & {
  __typename?: 'TaskMentionNotification';
  blockId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mentionBlockUrl: Scalars['String']['output'];
  readAt: Maybe<Scalars['String']['output']>;
  spaceColor: Maybe<Scalars['String']['output']>;
  spaceId: Scalars['String']['output'];
  spaceTitle: Scalars['String']['output'];
  spaceUrlKey: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  taskTitle: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type Template = Node & {
  __typename?: 'Template';
  aliases: Array<Scalars['String']['output']>;
  blocks: Scalars['JSON']['output'];
  icon: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type UpdateAiPromptsInput = {
  id: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CustomPromptType>;
};

export type UpdateMemberRoleInput = {
  role: Role;
  urlKey: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UpdatePageSharedToSpaceInput = {
  isPrivateInSpace: Scalars['Boolean']['input'];
  pageId: Scalars['String']['input'];
  urlKey: Scalars['String']['input'];
};

export type UpdateSpaceMetadataInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  isCopyWorkspaceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isEmbeddingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  urlKey: Scalars['String']['input'];
};

export type UpdateSpacePublicMetadataInput = {
  isCopyWorkspaceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  urlKey: Scalars['String']['input'];
};

export type UpdateSpaceSortingInput = {
  sortedUrlKeys: Array<Scalars['String']['input']>;
};

export type UpdateSpaceUseCasesInput = {
  urlKey: Scalars['String']['input'];
  useCases: Array<Scalars['String']['input']>;
};

export type UpdateUserLanguageInput = {
  language: Language;
};

export type UpdateUserNameInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type UpdateUserPagePermissionInput = {
  pageId: Scalars['String']['input'];
  permission: PagePermission;
  spaceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  userType: UserTypePagePermission;
};

export type UpdateUserSettingsInput = {
  editorFont?: InputMaybe<Scalars['String']['input']>;
  extendedSettings?: InputMaybe<ExtendedSettingsInput>;
  hiddenDefaultPrompts?: InputMaybe<Array<Scalars['String']['input']>>;
  interfaceFont?: InputMaybe<Scalars['String']['input']>;
  showInlinePageLinkIcons?: InputMaybe<Scalars['Boolean']['input']>;
  sortedSpaces?: InputMaybe<Array<Scalars['String']['input']>>;
  weekStartOnMonday?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['String']['output'];
  customerId: Maybe<Scalars['String']['output']>;
  data: UserData;
  id: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type UserData = {
  __typename?: 'UserData';
  agreedToTerms: Scalars['Boolean']['output'];
  agreedToTermsDate: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  language: Language;
  lastName: Scalars['String']['output'];
  optInTracking: Scalars['Boolean']['output'];
  role: UserRole;
};

export type UserDelete = {
  __typename?: 'UserDelete';
  status: UserDeleteStatus;
  userId: Scalars['String']['output'];
};

export enum UserDeleteStatus {
  Deleted = 'DELETED',
  NotFound = 'NOT_FOUND',
  Success = 'SUCCESS'
}

export type UserIntegration = {
  __typename?: 'UserIntegration';
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  type: UserIntegrationType;
};

export enum UserIntegrationType {
  GoogleDrive = 'GOOGLE_DRIVE',
  Linear = 'LINEAR'
}

export type UserListSharedCount = {
  __typename?: 'UserListSharedCount';
  publicPagesCount: Scalars['Int']['output'];
  publicSpacesCount: Scalars['Int']['output'];
};

export type UserMembership = {
  __typename?: 'UserMembership';
  publicPages: Array<Maybe<SharedPage>>;
  role: Role;
  spaceDeletable: Scalars['Boolean']['output'];
  spaceId: Scalars['String']['output'];
  spaceName: Scalars['String']['output'];
};

export type UserPagePermission = {
  __typename?: 'UserPagePermission';
  pageId: Scalars['String']['output'];
  permission: PagePermission;
  spaceId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UserPagePermissionsBySpaceIdInput = {
  spaceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export enum UserRole {
  Admin = 'ADMIN',
  God = 'GOD',
  User = 'USER'
}

export type UserSettings = {
  __typename?: 'UserSettings';
  customAIPrompts: Array<CustomAiPrompt>;
  editorFont: Maybe<Scalars['String']['output']>;
  extendedSettings: Maybe<ExtendedSettings>;
  hiddenDefaultPrompts: Array<Scalars['String']['output']>;
  interfaceFont: Maybe<Scalars['String']['output']>;
  showInlinePageLinkIcons: Scalars['Boolean']['output'];
  spaceSorting: Array<Scalars['String']['output']>;
  weekStartOnMonday: Scalars['Boolean']['output'];
};

export enum UserTypePagePermission {
  Guest = 'GUEST',
  Member = 'MEMBER'
}

export type UserWithDetails = {
  __typename?: 'UserWithDetails';
  createdAt: Scalars['Date']['output'];
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  integrations: Array<UserIntegration>;
  lastName: Maybe<Scalars['String']['output']>;
  membership: Maybe<Array<UserMembership>>;
  role: UserRole;
  updatedAt: Scalars['Date']['output'];
};

export type WorkspaceCollaborationNotification = Node & Notification & {
  __typename?: 'WorkspaceCollaborationNotification';
  activeSubscription: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inviteId: Maybe<Scalars['String']['output']>;
  readAt: Maybe<Scalars['String']['output']>;
  spaceColor: Maybe<Scalars['String']['output']>;
  spaceId: Scalars['String']['output'];
  spaceTitle: Scalars['String']['output'];
  spaceUrlKey: Scalars['String']['output'];
  type: WorkspaceCollaborationNotificationType;
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export enum WorkspaceCollaborationNotificationType {
  WorkspaceInvite = 'WorkspaceInvite',
  WorkspaceJoined = 'WorkspaceJoined',
  WorkspaceLeft = 'WorkspaceLeft',
  WorkspaceMemberRemoved = 'WorkspaceMemberRemoved'
}

export type SubscriptionFragmentFragment = { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } };

export type SpaceFragmentFragment = { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color: string | null, owner: string, useCases: Array<string>, activeSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit: number | null }, guests: { __typename?: 'FeaturePermission', limit: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } };

export type SpaceWithMembersFragment = { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color: string | null, owner: string, useCases: Array<string>, members: Array<{ __typename?: 'Member', id: string, spaceId: string, firstName: string, lastName: string, userEmail: string | null, role: Role | null }>, activeSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit: number | null }, guests: { __typename?: 'FeaturePermission', limit: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } };

export type UserFragmentFragment = { __typename?: 'User', id: string, createdAt: string, updatedAt: string, data: { __typename?: 'UserData', email: string, firstName: string, lastName: string, agreedToTerms: boolean, agreedToTermsDate: string | null, optInTracking: boolean, language: Language, role: UserRole } };

export type UserSettingsFragment = { __typename?: 'UserSettings', spaceSorting: Array<string>, showInlinePageLinkIcons: boolean, weekStartOnMonday: boolean, hiddenDefaultPrompts: Array<string>, interfaceFont: string | null, editorFont: string | null, customAIPrompts: Array<{ __typename?: 'CustomAIPrompt', id: string, title: string, prompt: string, position: number, type: CustomPromptType }>, extendedSettings: { __typename?: 'ExtendedSettings', pagesColumnsOrder: Array<string> | null, sharedPagesColumnsOrder: Array<string> | null, tasksColumnsOrder: Array<string> | null, collectionsColumnsOrder: Array<string> | null, collectionPropertiesOrder: Array<{ __typename?: 'CollectionPropertyOrder', collectionId: string, tagViewProperties: Array<string>, folderViewProperties: Array<string> }> | null } | null };

export type ExtendedSettingsFragment = { __typename?: 'ExtendedSettings', pagesColumnsOrder: Array<string> | null, sharedPagesColumnsOrder: Array<string> | null, tasksColumnsOrder: Array<string> | null, collectionsColumnsOrder: Array<string> | null, collectionPropertiesOrder: Array<{ __typename?: 'CollectionPropertyOrder', collectionId: string, tagViewProperties: Array<string>, folderViewProperties: Array<string> }> | null };

export type CustomAiPromptsFragment = { __typename?: 'CustomAIPrompt', id: string, title: string, prompt: string, position: number, type: CustomPromptType };

export type MemberFragmentFragment = { __typename?: 'Member', id: string, spaceId: string, firstName: string, lastName: string, userEmail: string | null, role: Role | null };

export type PublicMemberFragment = { __typename?: 'Member', id: string, spaceId: string, firstName: string, lastName: string };

export type InviteFragmentFragment = { __typename?: 'Invite', id: string, userEmail: string, role: Role };

export type InviteMetaDataFragmentFragment = { __typename?: 'InviteMetaData', inviteId: string, workspaceTitle: string, workspaceOwnerEmail: string, workspaceMembersCount: number, userEmail: string };

export type PageInviteMetaFragmentFragment = { __typename?: 'PageInviteMeta', id: string, userEmail: string, inviterEmail: string, title: string, role: PagePermission };

export type PageInviteFragmentFragment = { __typename?: 'PageInvite', id: string, userEmail: string, role: PagePermission };

export type PageIconFragmentFragment = { __typename?: 'PageIcon', type: string, colons: string };

export type PageFragmentFragment = { __typename?: 'Page', id: string, title: string, collections: Array<string>, aliases: Array<string>, archivedAt: string | null, isTemplate: boolean | null, isPublicDuplicatable: boolean | null, spaceId: string, staticBlocks: any, icon: { __typename?: 'PageIcon', type: string, colons: string } | null, settings: { __typename?: 'PageSettings', fullWidth: boolean | null } };

export type PageAndPermissionFragmentFragment = { __typename?: 'PageAndPermission', permission: PagePermission, page: { __typename?: 'Page', id: string, title: string, collections: Array<string>, aliases: Array<string>, archivedAt: string | null, isTemplate: boolean | null, isPublicDuplicatable: boolean | null, spaceId: string, staticBlocks: any, icon: { __typename?: 'PageIcon', type: string, colons: string } | null, settings: { __typename?: 'PageSettings', fullWidth: boolean | null } } };

export type SharedPageFragmentFragment = { __typename?: 'SharedPage', id: string, spaceId: string, isPrivateInSpace: boolean, isPublic: boolean, createdAt: any, updatedAt: any };

export type SharedPageInfoFragmentFragment = { __typename?: 'SharedPageInfo', title: string, permission: PagePermission, sharedBy: string, page: { __typename?: 'SharedPage', id: string, spaceId: string, isPrivateInSpace: boolean, isPublic: boolean, createdAt: any, updatedAt: any }, icon: { __typename?: 'PageIcon', type: string, colons: string } | null };

export type AiChatMessageFragmentFragment = { __typename?: 'AIChatMessage', content: string | null, role: AiChatRole, tool_calls: any | null, tool_call_id: string | null, createdAt: any };

export type AiChatThreadFragmentFragment = { __typename?: 'AIChatThread', id: string, spaceId: string, userId: string, messages: Array<{ __typename?: 'AIChatMessage', content: string | null, role: AiChatRole, tool_calls: any | null, tool_call_id: string | null, createdAt: any }> };

export type CollectionFragmentFragment = { __typename?: 'Collection', id: string, title: string, updatedAt: string };

export type GoogleDriveFileFragment = { __typename?: 'GoogleDriveFile', id: string, name: string, webViewLink: string, iconLink: string | null, thumbnailLink: string | null, modifiedTime: string | null, mimeType: string | null, owners: Array<{ __typename?: 'GoogleDriveOwner', displayName: string | null } | null> | null };

export type LinearIssueFragment = { __typename?: 'LinearIssue', id: string, identifier: string, title: string, url: string, description: string | null, updatedAt: any, priorityLabel: string | null, priority: number, state: { __typename?: 'LinearIssueState', name: string, color: string, type: string } | null, assignee: { __typename?: 'LinearUser', name: string } | null };

export type LinearTeamFragment = { __typename?: 'LinearTeam', id: string, name: string };

export type MentionNotificationFragment = { __typename?: 'MentionNotification', id: string, spaceTitle: string, spaceColor: string | null, pageTitle: string, pageId: string, blockId: string, spaceId: string, spaceUrlKey: string, userId: string, readAt: string | null, createdAt: string, username: string, mentionBlockUrl: string };

export type TaskMentionNotificationFragment = { __typename?: 'TaskMentionNotification', id: string, spaceTitle: string, spaceColor: string | null, taskTitle: string, taskId: string, blockId: string, spaceId: string, spaceUrlKey: string, userId: string, readAt: string | null, createdAt: string, username: string, mentionBlockUrl: string };

export type TaskAssignmentNotificationFragment = { __typename?: 'TaskAssignmentNotification', id: string, spaceTitle: string, spaceColor: string | null, taskId: string, taskTitle: string, taskUrl: string, action: TaskAssignAction, spaceId: string, spaceUrlKey: string, userId: string, readAt: string | null, createdAt: string, username: string };

export type PageInviteNotificationFragment = { __typename?: 'PageInviteNotification', id: string, spaceTitle: string, spaceColor: string | null, pageTitle: string, pageId: string, readAt: string | null, createdAt: string, username: string, userId: string, inviteId: string | null };

export type WorkspaceCollaborationNotificationFragment = { __typename?: 'WorkspaceCollaborationNotification', id: string, spaceTitle: string, spaceColor: string | null, readAt: string | null, createdAt: string, spaceId: string, spaceUrlKey: string, username: string, userId: string, type: WorkspaceCollaborationNotificationType, inviteId: string | null, activeSubscription: boolean };

export type FullPageInfoFragment = { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null };

export type TemplateFragment = { __typename?: 'Template', id: string, title: string, icon: string | null, blocks: any, aliases: Array<string> };

export type AiEmbeddingFragment = { __typename?: 'AIEmbedding', pageId: string, fromBlockId: string, toBlockId: string, distance: number };

export type UserPagePermissionFragmentFragment = { __typename?: 'UserPagePermission', userId: string, pageId: string, spaceId: string, permission: PagePermission };

export type PageMemberFragmentFragment = { __typename?: 'PageMember', firstName: string, lastName: string, userEmail: string | null, userId: string, pageId: string, permission: PagePermission };

export type PageHistorySnapshotFragment = { __typename?: 'PageHistorySnapshot', updatedAt: any, buffer: string, authorEmail: string | null };

export type NotificationsConnectionQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
}>;


export type NotificationsConnectionQuery = { __typename?: 'Query', notificationsConnection: { __typename?: 'NotificationsConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename?: 'NotificationEdge', cursor: string, node: { __typename: 'MentionNotification', id: string, createdAt: string, spaceTitle: string, spaceColor: string | null, readAt: string | null, pageTitle: string, pageId: string, blockId: string, spaceId: string, spaceUrlKey: string, userId: string, username: string, mentionBlockUrl: string } | { __typename: 'PageInviteNotification', id: string, createdAt: string, spaceTitle: string, spaceColor: string | null, readAt: string | null, pageTitle: string, pageId: string, username: string, userId: string, inviteId: string | null } | { __typename: 'TaskAssignmentNotification', id: string, createdAt: string, spaceTitle: string, spaceColor: string | null, readAt: string | null, taskId: string, taskTitle: string, taskUrl: string, action: TaskAssignAction, spaceId: string, spaceUrlKey: string, userId: string, username: string } | { __typename: 'TaskMentionNotification', id: string, createdAt: string, spaceTitle: string, spaceColor: string | null, readAt: string | null, taskTitle: string, taskId: string, blockId: string, spaceId: string, spaceUrlKey: string, userId: string, username: string, mentionBlockUrl: string } | { __typename: 'WorkspaceCollaborationNotification', id: string, createdAt: string, spaceTitle: string, spaceColor: string | null, readAt: string | null, spaceId: string, spaceUrlKey: string, username: string, userId: string, type: WorkspaceCollaborationNotificationType, inviteId: string | null, activeSubscription: boolean } }> } };

export type SpacesQueryVariables = Exact<{ [key: string]: never; }>;


export type SpacesQuery = { __typename?: 'Query', spaces: Array<{ __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color: string | null, owner: string, useCases: Array<string>, activeSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit: number | null }, guests: { __typename?: 'FeaturePermission', limit: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } }> };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, createdAt: string, updatedAt: string, data: { __typename?: 'UserData', email: string, firstName: string, lastName: string, agreedToTerms: boolean, agreedToTermsDate: string | null, optInTracking: boolean, language: Language, role: UserRole } } | null };

export type UserDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDataQuery = { __typename?: 'Query', cannyToken: string | null, currentUser: { __typename?: 'User', id: string, createdAt: string, updatedAt: string, data: { __typename?: 'UserData', email: string, firstName: string, lastName: string, agreedToTerms: boolean, agreedToTermsDate: string | null, optInTracking: boolean, language: Language, role: UserRole } } | null, getCustomToken: { __typename?: 'CustomToken', token: string }, spaces: Array<{ __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color: string | null, owner: string, useCases: Array<string>, members: Array<{ __typename?: 'Member', id: string, spaceId: string, firstName: string, lastName: string, userEmail: string | null, role: Role | null }>, activeSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit: number | null }, guests: { __typename?: 'FeaturePermission', limit: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } }>, userSettings: { __typename?: 'UserSettings', spaceSorting: Array<string>, showInlinePageLinkIcons: boolean, weekStartOnMonday: boolean, hiddenDefaultPrompts: Array<string>, interfaceFont: string | null, editorFont: string | null, customAIPrompts: Array<{ __typename?: 'CustomAIPrompt', id: string, title: string, prompt: string, position: number, type: CustomPromptType }>, extendedSettings: { __typename?: 'ExtendedSettings', pagesColumnsOrder: Array<string> | null, sharedPagesColumnsOrder: Array<string> | null, tasksColumnsOrder: Array<string> | null, collectionsColumnsOrder: Array<string> | null, collectionPropertiesOrder: Array<{ __typename?: 'CollectionPropertyOrder', collectionId: string, tagViewProperties: Array<string>, folderViewProperties: Array<string> }> | null } | null } | null };

export type UserInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInvitesQuery = { __typename?: 'Query', userInvites: Array<{ __typename?: 'InviteMetaData', inviteId: string, workspaceTitle: string, workspaceOwnerEmail: string, workspaceMembersCount: number, userEmail: string }> };

export type SpaceByUrlKeyQueryVariables = Exact<{
  input: SpaceByUrlKeyInput;
}>;


export type SpaceByUrlKeyQuery = { __typename?: 'Query', spaceByUrlKey: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color: string | null, owner: string, useCases: Array<string>, members: Array<{ __typename?: 'Member', id: string, spaceId: string, firstName: string, lastName: string, userEmail: string | null, role: Role | null }>, activeSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit: number | null }, guests: { __typename?: 'FeaturePermission', limit: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } | null };

export type InvitesAndMembersQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type InvitesAndMembersQuery = { __typename?: 'Query', members: Array<{ __typename?: 'Member', id: string, spaceId: string, firstName: string, lastName: string, userEmail: string | null, role: Role | null }>, invites: Array<{ __typename?: 'Invite', id: string, userEmail: string, role: Role }> };

export type MembersQueryVariables = Exact<{
  input: MembersInput;
}>;


export type MembersQuery = { __typename?: 'Query', members: Array<{ __typename?: 'Member', id: string, spaceId: string, firstName: string, lastName: string }> };

export type InviteMetaDataQueryVariables = Exact<{
  input: InviteMetaDataInput;
}>;


export type InviteMetaDataQuery = { __typename?: 'Query', inviteMetaData: { __typename?: 'InviteMetaData', inviteId: string, workspaceTitle: string, workspaceOwnerEmail: string, workspaceMembersCount: number, userEmail: string } | null };

export type PageQueryVariables = Exact<{
  input: PageInput;
}>;


export type PageQuery = { __typename?: 'Query', page: { __typename?: 'PageAndPermission', permission: PagePermission, page: { __typename?: 'Page', id: string, title: string, collections: Array<string>, aliases: Array<string>, archivedAt: string | null, isTemplate: boolean | null, isPublicDuplicatable: boolean | null, spaceId: string, staticBlocks: any, icon: { __typename?: 'PageIcon', type: string, colons: string } | null, settings: { __typename?: 'PageSettings', fullWidth: boolean | null } } } | null };

export type SharedPageStatusQueryVariables = Exact<{
  input: PageInput;
}>;


export type SharedPageStatusQuery = { __typename?: 'Query', sharedPageStatus: { __typename?: 'SharedPage', id: string, spaceId: string, isPrivateInSpace: boolean, isPublic: boolean, createdAt: any, updatedAt: any } | null };

export type AllSharedPagesStatusesByUrlKeyQueryVariables = Exact<{
  input: PagesByUrlKeyInput;
}>;


export type AllSharedPagesStatusesByUrlKeyQuery = { __typename?: 'Query', allSharedPagesStatusesByUrlKey: Array<{ __typename?: 'SharedPage', id: string, spaceId: string, isPrivateInSpace: boolean, isPublic: boolean, createdAt: any, updatedAt: any }> };

export type PagesByUrlKeyQueryVariables = Exact<{
  input: PagesByUrlKeyInput;
}>;


export type PagesByUrlKeyQuery = { __typename?: 'Query', pagesByUrlKey: Array<{ __typename?: 'Page', id: string, title: string, collections: Array<string>, aliases: Array<string>, archivedAt: string | null, isTemplate: boolean | null, isPublicDuplicatable: boolean | null, spaceId: string, staticBlocks: any, icon: { __typename?: 'PageIcon', type: string, colons: string } | null, settings: { __typename?: 'PageSettings', fullWidth: boolean | null } }> };

export type CollectionsByUrlKeyQueryVariables = Exact<{
  input: CollectionsByUrlKeyInput;
}>;


export type CollectionsByUrlKeyQuery = { __typename?: 'Query', collectionsByUrlKey: Array<{ __typename?: 'Collection', id: string, title: string, updatedAt: string }> };

export type GetCustomTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomTokenQuery = { __typename?: 'Query', getCustomToken: { __typename?: 'CustomToken', token: string } };

export type SearchIntegrationsQueryVariables = Exact<{
  input: IntegrationSearchInput;
}>;


export type SearchIntegrationsQuery = { __typename?: 'Query', searchIntegrations: { __typename?: 'IntegrationSearchResult', googleDriveFiles: Array<{ __typename?: 'GoogleDriveFile', id: string, name: string, webViewLink: string, iconLink: string | null, thumbnailLink: string | null, modifiedTime: string | null, mimeType: string | null, owners: Array<{ __typename?: 'GoogleDriveOwner', displayName: string | null } | null> | null }>, linearIssues: Array<{ __typename?: 'LinearIssue', id: string, identifier: string, title: string, url: string, description: string | null, updatedAt: any, priorityLabel: string | null, priority: number, state: { __typename?: 'LinearIssueState', name: string, color: string, type: string } | null, assignee: { __typename?: 'LinearUser', name: string } | null }> } };

export type LinearIssueQueryVariables = Exact<{
  input: LinearIssueInput;
}>;


export type LinearIssueQuery = { __typename?: 'Query', linearIssue: { __typename?: 'LinearIssue', id: string, identifier: string, title: string, url: string, description: string | null, updatedAt: any, priorityLabel: string | null, priority: number, state: { __typename?: 'LinearIssueState', name: string, color: string, type: string } | null, assignee: { __typename?: 'LinearUser', name: string } | null } };

export type GoogleDriveDocumentQueryVariables = Exact<{
  input: GoogleDriveFileInput;
}>;


export type GoogleDriveDocumentQuery = { __typename?: 'Query', googleDriveDocument: { __typename?: 'GoogleDriveFile', id: string, name: string, webViewLink: string, iconLink: string | null, thumbnailLink: string | null, modifiedTime: string | null, mimeType: string | null, owners: Array<{ __typename?: 'GoogleDriveOwner', displayName: string | null } | null> | null } };

export type UserIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserIntegrationsQuery = { __typename?: 'Query', userIntegrations: Array<{ __typename?: 'UserIntegration', id: string, type: UserIntegrationType, isActive: boolean }> };

export type UnreadNotificationsCounterQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadNotificationsCounterQuery = { __typename?: 'Query', unreadNotificationsCounter: number | null };

export type TemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type TemplatesQuery = { __typename?: 'Query', templates: Array<{ __typename?: 'Template', id: string, title: string, icon: string | null, blocks: any, aliases: Array<string> }> };

export type LinearTeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type LinearTeamsQuery = { __typename?: 'Query', linearTeams: Array<{ __typename?: 'LinearTeam', id: string, name: string }> };

export type SubscriptionPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionPlansQuery = { __typename?: 'Query', subscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', id: string, stripeId: string, featureSet: FeatureSet, price: Array<{ __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string }> }> };

export type InvoicesQueryVariables = Exact<{
  input: InvoicesInput;
}>;


export type InvoicesQuery = { __typename?: 'Query', invoices: Array<{ __typename?: 'Invoices', id: string, subscriptionId: string, created: any, paid: boolean, total: number, pdfUrl: string | null }> };

export type SubscriptionUpcomingQueryVariables = Exact<{
  input: SubscriptionUpcomingInput;
}>;


export type SubscriptionUpcomingQuery = { __typename?: 'Query', subscriptionUpcoming: { __typename?: 'SubscriptionUpcoming', periodStart: any, periodEnd: any, paid: boolean, total: number, created: any } | null };

export type SpaceEmbeddingsQueryVariables = Exact<{
  input: EmbeddingSearchInput;
}>;


export type SpaceEmbeddingsQuery = { __typename?: 'Query', spaceEmbeddings: Array<{ __typename?: 'AIEmbedding', pageId: string, fromBlockId: string, toBlockId: string, distance: number }> };

export type AdminUserListQueryVariables = Exact<{
  input: AdminUserListInput;
}>;


export type AdminUserListQuery = { __typename?: 'Query', adminUserList: { __typename?: 'AdminUserList', users: Array<{ __typename?: 'AdminUser', id: string, email: string, names: string, role: UserRole, createdAt: string, updatedAt: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } };

export type AdminUserListSharedCountQueryVariables = Exact<{
  input: AdminUserListSharedCountInput;
}>;


export type AdminUserListSharedCountQuery = { __typename?: 'Query', adminUserListSharedCount: { __typename?: 'UserListSharedCount', publicPagesCount: number, publicSpacesCount: number } };

export type AdminSpaceListQueryVariables = Exact<{
  input: AdminSpaceListInput;
}>;


export type AdminSpaceListQuery = { __typename?: 'Query', adminSpaceList: { __typename?: 'AdminSpaceList', id: string, title: string, urlKey: string, createdAt: string, ownerIds: Array<string | null>, usedSpaceTokens: number, activeSubscription: { __typename?: 'SpaceSubscription', id: string, status: string, canceled: boolean, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, plan: { __typename?: 'SpaceSubscriptionPlan', id: string } } | null } };

export type SpacePermissionsQueryVariables = Exact<{
  input: SpaceByUrlKeyInput;
}>;


export type SpacePermissionsQuery = { __typename?: 'Query', spacePermissions: { __typename?: 'SpacePermissions', sagaAiStatus: string } };

export type BillingPortalQueryVariables = Exact<{
  input: BillingPortalInput;
}>;


export type BillingPortalQuery = { __typename?: 'Query', billingPortal: string };

export type UserPagePermissionsBySpaceIdQueryVariables = Exact<{
  input: UserPagePermissionsBySpaceIdInput;
}>;


export type UserPagePermissionsBySpaceIdQuery = { __typename?: 'Query', userPagePermissionsBySpaceId: Array<{ __typename?: 'UserPagePermission', userId: string, pageId: string, spaceId: string, permission: PagePermission }> };

export type PageInvitesAndMembersQueryVariables = Exact<{
  pageId: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
}>;


export type PageInvitesAndMembersQuery = { __typename?: 'Query', pageMembers: Array<{ __typename?: 'PageMember', firstName: string, lastName: string, userEmail: string | null, userId: string, pageId: string, permission: PagePermission }>, pageInvites: Array<{ __typename?: 'PageInvite', id: string, userEmail: string, role: PagePermission }> };

export type PageInviteMetaDataQueryVariables = Exact<{
  input: PageInviteMetaInput;
}>;


export type PageInviteMetaDataQuery = { __typename?: 'Query', pageInviteMetaData: { __typename?: 'PageInviteMeta', id: string, userEmail: string, inviterEmail: string, title: string, role: PagePermission } | null };

export type UserPageInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPageInvitesQuery = { __typename?: 'Query', userPageInvites: Array<{ __typename?: 'PageInviteMeta', id: string, userEmail: string, inviterEmail: string, title: string, role: PagePermission }> };

export type UserSharedPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSharedPagesQuery = { __typename?: 'Query', userSharedPages: Array<{ __typename?: 'SharedPageInfo', title: string, permission: PagePermission, sharedBy: string, page: { __typename?: 'SharedPage', id: string, spaceId: string, isPrivateInSpace: boolean, isPublic: boolean, createdAt: any, updatedAt: any }, icon: { __typename?: 'PageIcon', type: string, colons: string } | null }> };

export type ChatThreadsQueryVariables = Exact<{
  input: ChatThreadsInput;
}>;


export type ChatThreadsQuery = { __typename?: 'Query', chatThreads: Array<{ __typename?: 'AIChatThread', id: string, spaceId: string, userId: string, messages: Array<{ __typename?: 'AIChatMessage', content: string | null, role: AiChatRole, tool_calls: any | null, tool_call_id: string | null, createdAt: any }> }> };

export type PageHistoryQueryVariables = Exact<{
  input: PageHistoryInput;
}>;


export type PageHistoryQuery = { __typename?: 'Query', pageHistory: Array<{ __typename?: 'PageHistorySnapshot', updatedAt: any, buffer: string, authorEmail: string | null }> };

export type AdminUserDetailsMutationVariables = Exact<{
  input: AdminUserDetailsInput;
}>;


export type AdminUserDetailsMutation = { __typename?: 'Mutation', adminUserDetails: { __typename?: 'UserWithDetails', id: string, email: string | null, firstName: string | null, lastName: string | null, role: UserRole, createdAt: any, updatedAt: any, membership: Array<{ __typename?: 'UserMembership', spaceId: string, spaceName: string, spaceDeletable: boolean, role: Role, publicPages: Array<{ __typename?: 'SharedPage', id: string, spaceId: string, isPrivateInSpace: boolean, isPublic: boolean, createdAt: any, updatedAt: any } | null> }> | null, integrations: Array<{ __typename?: 'UserIntegration', id: string, type: UserIntegrationType, isActive: boolean }> } };

export type AdminUserDeleteMutationVariables = Exact<{
  input: AdminUsersDeleteInput;
}>;


export type AdminUserDeleteMutation = { __typename?: 'Mutation', adminUserDelete: Array<{ __typename?: 'UserDelete', userId: string, status: UserDeleteStatus }> };

export type UpdateUserNameMutationVariables = Exact<{
  input: UpdateUserNameInput;
}>;


export type UpdateUserNameMutation = { __typename?: 'Mutation', updateUserName: { __typename?: 'User', id: string, createdAt: string, updatedAt: string, data: { __typename?: 'UserData', email: string, firstName: string, lastName: string, agreedToTerms: boolean, agreedToTermsDate: string | null, optInTracking: boolean, language: Language, role: UserRole } } };

export type UpdateUserLanguageMutationVariables = Exact<{
  input: UpdateUserLanguageInput;
}>;


export type UpdateUserLanguageMutation = { __typename?: 'Mutation', updateUserLanguage: { __typename?: 'User', id: string, createdAt: string, updatedAt: string, data: { __typename?: 'UserData', email: string, firstName: string, lastName: string, agreedToTerms: boolean, agreedToTermsDate: string | null, optInTracking: boolean, language: Language, role: UserRole } } };

export type SignupMutationVariables = Exact<{
  input: SignupInput;
}>;


export type SignupMutation = { __typename?: 'Mutation', signup: { __typename?: 'User', id: string, createdAt: string, updatedAt: string, data: { __typename?: 'UserData', email: string, firstName: string, lastName: string, agreedToTerms: boolean, agreedToTermsDate: string | null, optInTracking: boolean, language: Language, role: UserRole } } };

export type CreateSpaceMutationVariables = Exact<{
  input: CreateSpaceInput;
}>;


export type CreateSpaceMutation = { __typename?: 'Mutation', createSpace: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color: string | null, owner: string, useCases: Array<string>, activeSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit: number | null }, guests: { __typename?: 'FeaturePermission', limit: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } };

export type CreatePageMutationVariables = Exact<{
  input: CreatePageInput;
}>;


export type CreatePageMutation = { __typename?: 'Mutation', createPage: { __typename?: 'Page', id: string, title: string, collections: Array<string>, aliases: Array<string>, archivedAt: string | null, isTemplate: boolean | null, isPublicDuplicatable: boolean | null, spaceId: string, staticBlocks: any, icon: { __typename?: 'PageIcon', type: string, colons: string } | null, settings: { __typename?: 'PageSettings', fullWidth: boolean | null } } };

export type DeleteSpaceMutationVariables = Exact<{
  input: DeleteSpaceInput;
}>;


export type DeleteSpaceMutation = { __typename?: 'Mutation', deleteSpace: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color: string | null, owner: string, useCases: Array<string>, activeSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit: number | null }, guests: { __typename?: 'FeaturePermission', limit: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } };

export type CopyWorkspaceMutationVariables = Exact<{
  input: CopyWorkspaceInput;
}>;


export type CopyWorkspaceMutation = { __typename?: 'Mutation', copyWorkspace: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color: string | null, owner: string, useCases: Array<string>, activeSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit: number | null }, guests: { __typename?: 'FeaturePermission', limit: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } };

export type UpdateSpaceSortingMutationVariables = Exact<{
  input: UpdateSpaceSortingInput;
}>;


export type UpdateSpaceSortingMutation = { __typename?: 'Mutation', updateSpaceSorting: Array<{ __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color: string | null, owner: string, useCases: Array<string>, activeSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit: number | null }, guests: { __typename?: 'FeaturePermission', limit: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } }> };

export type UpdateUserSettingsMutationVariables = Exact<{
  input: UpdateUserSettingsInput;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'Mutation', updateUserSettings: { __typename?: 'UserSettings', spaceSorting: Array<string>, showInlinePageLinkIcons: boolean, weekStartOnMonday: boolean, hiddenDefaultPrompts: Array<string>, interfaceFont: string | null, editorFont: string | null, customAIPrompts: Array<{ __typename?: 'CustomAIPrompt', id: string, title: string, prompt: string, position: number, type: CustomPromptType }>, extendedSettings: { __typename?: 'ExtendedSettings', pagesColumnsOrder: Array<string> | null, sharedPagesColumnsOrder: Array<string> | null, tasksColumnsOrder: Array<string> | null, collectionsColumnsOrder: Array<string> | null, collectionPropertiesOrder: Array<{ __typename?: 'CollectionPropertyOrder', collectionId: string, tagViewProperties: Array<string>, folderViewProperties: Array<string> }> | null } | null } };

export type UpdateAiPromptsMutationVariables = Exact<{
  input: Array<UpdateAiPromptsInput> | UpdateAiPromptsInput;
}>;


export type UpdateAiPromptsMutation = { __typename?: 'Mutation', updateAIPrompts: Array<{ __typename?: 'CustomAIPrompt', id: string, title: string, prompt: string, position: number, type: CustomPromptType }> | null };

export type AddAiPromptMutationVariables = Exact<{
  input: AddAiPromptInput;
}>;


export type AddAiPromptMutation = { __typename?: 'Mutation', addAIPrompt: { __typename?: 'CustomAIPrompt', id: string, title: string, prompt: string, position: number, type: CustomPromptType } };

export type RemoveAiPromptMutationVariables = Exact<{
  input: RemoveAiPromptInput;
}>;


export type RemoveAiPromptMutation = { __typename?: 'Mutation', removeAIPrompt: boolean };

export type InviteMembersMutationVariables = Exact<{
  input: InviteMembersInput;
}>;


export type InviteMembersMutation = { __typename?: 'Mutation', inviteMembers: Array<{ __typename?: 'Invite', id: string, userEmail: string, role: Role }> };

export type RevokeInviteMutationVariables = Exact<{
  input: RevokeInviteInput;
}>;


export type RevokeInviteMutation = { __typename?: 'Mutation', revokeInvite: { __typename?: 'Invite', id: string, userEmail: string, role: Role } };

export type AcceptInvitationMutationVariables = Exact<{
  input: AcceptInvitationInput;
}>;


export type AcceptInvitationMutation = { __typename?: 'Mutation', acceptInvitation: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color: string | null, owner: string, useCases: Array<string>, activeSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit: number | null }, guests: { __typename?: 'FeaturePermission', limit: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } };

export type RemoveMemberMutationVariables = Exact<{
  input: RemoveMemberInput;
}>;


export type RemoveMemberMutation = { __typename?: 'Mutation', removeMember: string };

export type UpdateMemberRoleMutationVariables = Exact<{
  input: UpdateMemberRoleInput;
}>;


export type UpdateMemberRoleMutation = { __typename?: 'Mutation', updateMemberRole: { __typename?: 'Member', id: string, spaceId: string, firstName: string, lastName: string, userEmail: string | null, role: Role | null } };

export type LeaveSpaceMutationVariables = Exact<{
  input: LeaveSpaceInput;
}>;


export type LeaveSpaceMutation = { __typename?: 'Mutation', leaveSpace: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color: string | null, owner: string, useCases: Array<string>, activeSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit: number | null }, guests: { __typename?: 'FeaturePermission', limit: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } };

export type UpdateSpaceMetadataMutationVariables = Exact<{
  input: UpdateSpaceMetadataInput;
}>;


export type UpdateSpaceMetadataMutation = { __typename?: 'Mutation', updateSpaceMetadata: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color: string | null, owner: string, useCases: Array<string>, activeSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit: number | null }, guests: { __typename?: 'FeaturePermission', limit: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } };

export type UpdateSpacePublicMetadataMutationVariables = Exact<{
  input: UpdateSpacePublicMetadataInput;
}>;


export type UpdateSpacePublicMetadataMutation = { __typename?: 'Mutation', updateSpacePublicMetadata: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color: string | null, owner: string, useCases: Array<string>, activeSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit: number | null }, guests: { __typename?: 'FeaturePermission', limit: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } };

export type UpdateSpaceUseCasesMutationVariables = Exact<{
  input: UpdateSpaceUseCasesInput;
}>;


export type UpdateSpaceUseCasesMutation = { __typename?: 'Mutation', updateSpaceUseCases: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color: string | null, owner: string, useCases: Array<string>, activeSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit: number | null }, guests: { __typename?: 'FeaturePermission', limit: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } };

export type RequestSignInLinkMutationVariables = Exact<{
  input: RequestSignInLinkInput;
}>;


export type RequestSignInLinkMutation = { __typename?: 'Mutation', requestSignInLink: boolean };

export type AddBlocksMutationVariables = Exact<{
  input: AddBlocksInput;
}>;


export type AddBlocksMutation = { __typename?: 'Mutation', addBlocks: string | null };

export type SendTaskMentionNotificationMutationVariables = Exact<{
  input: SendTaskMentionNotificationInput;
}>;


export type SendTaskMentionNotificationMutation = { __typename?: 'Mutation', sendTaskMentionNotification: boolean };

export type SendTaskAssignmentNotificationMutationVariables = Exact<{
  input: SendTaskAssignmentNotificationInput;
}>;


export type SendTaskAssignmentNotificationMutation = { __typename?: 'Mutation', sendTaskAssignmentNotification: boolean };

export type SendNotificationMutationVariables = Exact<{
  input: SendNotificationInput;
}>;


export type SendNotificationMutation = { __typename?: 'Mutation', sendNotification: boolean };

export type RemoveUserIntegrationMutationVariables = Exact<{
  input: RemoveUserIntegrationInput;
}>;


export type RemoveUserIntegrationMutation = { __typename?: 'Mutation', removeUserIntegration: boolean };

export type MarkNotificationsAsReadMutationVariables = Exact<{
  input: MarkNotificationsAsReadInput;
}>;


export type MarkNotificationsAsReadMutation = { __typename?: 'Mutation', markNotificationsAsRead: Array<{ __typename: 'MentionNotification', id: string, readAt: string | null } | { __typename: 'PageInviteNotification', id: string, readAt: string | null } | { __typename: 'TaskAssignmentNotification', id: string, readAt: string | null } | { __typename: 'TaskMentionNotification', id: string, readAt: string | null } | { __typename: 'WorkspaceCollaborationNotification', id: string, readAt: string | null }> };

export type SharePageMutationVariables = Exact<{
  input: SharePageInput;
}>;


export type SharePageMutation = { __typename?: 'Mutation', sharePage: { __typename?: 'SharedPage', id: string } };

export type RemoveSharedPageMutationVariables = Exact<{
  input: RemoveSharedPageInput;
}>;


export type RemoveSharedPageMutation = { __typename?: 'Mutation', removeSharedPage: boolean };

export type InvitePageMembersMutationVariables = Exact<{
  input: InvitePageMembersInput;
}>;


export type InvitePageMembersMutation = { __typename?: 'Mutation', invitePageMembers: Array<{ __typename?: 'PageInvite', id: string, userEmail: string, role: PagePermission }> };

export type RevokePageInviteMutationVariables = Exact<{
  input: RevokePageInviteInput;
}>;


export type RevokePageInviteMutation = { __typename?: 'Mutation', revokePageInvite: { __typename?: 'PageInvite', id: string, userEmail: string, role: PagePermission } };

export type AcceptPageInvitationMutationVariables = Exact<{
  input: AcceptPageInvitationInput;
}>;


export type AcceptPageInvitationMutation = { __typename?: 'Mutation', acceptPageInvitation: { __typename?: 'SharedPage', id: string, spaceId: string, isPrivateInSpace: boolean, isPublic: boolean, createdAt: any, updatedAt: any } };

export type LinearIssueCreateMutationVariables = Exact<{
  input: LinearIssueCreateInput;
}>;


export type LinearIssueCreateMutation = { __typename?: 'Mutation', linearIssueCreate: { __typename?: 'LinearIssue', id: string, identifier: string, title: string, url: string, description: string | null, updatedAt: any, priorityLabel: string | null, priority: number, state: { __typename?: 'LinearIssueState', name: string, color: string, type: string } | null, assignee: { __typename?: 'LinearUser', name: string } | null } };

export type LinearIssueDeleteMutationVariables = Exact<{
  input: LinearIssueDeleteInput;
}>;


export type LinearIssueDeleteMutation = { __typename?: 'Mutation', linearIssueDelete: boolean };

export type CreateSubscriptionSessionMutationVariables = Exact<{
  input: CreateSubscriptionSessionInput;
}>;


export type CreateSubscriptionSessionMutation = { __typename?: 'Mutation', createSubscriptionSession: { __typename?: 'SubscriptionSession', session: string | null } };

export type CreateSubscriptionMutationVariables = Exact<{
  input: CreateSubscriptionInput;
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription: { __typename?: 'CreateSpaceSubscription', space: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color: string | null, owner: string, useCases: Array<string>, members: Array<{ __typename?: 'Member', id: string, spaceId: string, firstName: string, lastName: string, userEmail: string | null, role: Role | null }>, activeSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit: number | null }, guests: { __typename?: 'FeaturePermission', limit: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } | null } | null };

export type CancelSubscriptionMutationVariables = Exact<{
  input: CancelSubscriptionInput;
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } };

export type ChangeSubscriptionMutationVariables = Exact<{
  input: ChangeSubscriptionInput;
}>;


export type ChangeSubscriptionMutation = { __typename?: 'Mutation', changeSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } };

export type DeleteAssetMutationVariables = Exact<{
  input: DeleteAssetInput;
}>;


export type DeleteAssetMutation = { __typename?: 'Mutation', deleteAsset: boolean };

export type DuplicatePageAssetsMutationVariables = Exact<{
  input: DuplicatePageAssetsInput;
}>;


export type DuplicatePageAssetsMutation = { __typename?: 'Mutation', duplicatePageAssets: boolean };

export type UpdateUserPagePermissionMutationVariables = Exact<{
  input: UpdateUserPagePermissionInput;
}>;


export type UpdateUserPagePermissionMutation = { __typename?: 'Mutation', updateUserPagePermission: Array<{ __typename?: 'PageMember', firstName: string, lastName: string, userEmail: string | null, userId: string, pageId: string, permission: PagePermission }> };

export type UpdatePageSharedToSpaceMutationVariables = Exact<{
  input: UpdatePageSharedToSpaceInput;
}>;


export type UpdatePageSharedToSpaceMutation = { __typename?: 'Mutation', updatePageSharedToSpace: { __typename?: 'SharedPage', id: string, spaceId: string, isPrivateInSpace: boolean, isPublic: boolean, createdAt: any, updatedAt: any } };

export type HideAiThreadMutationVariables = Exact<{
  input: HideAiThreadInput;
}>;


export type HideAiThreadMutation = { __typename?: 'Mutation', hideAIThread: boolean };

export type UnreadNotificationsCounterUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UnreadNotificationsCounterUpdatedSubscription = { __typename?: 'Subscription', unreadNotificationsCounterUpdated: number };

export type PermissionsUpdatedSubscriptionVariables = Exact<{
  input: PermissionsUpdatedInput;
}>;


export type PermissionsUpdatedSubscription = { __typename?: 'Subscription', permissionsUpdated: { __typename?: 'SpacePermissions', sagaAiStatus: string } };

export type UserPagePermissionsBySpaceIdUpdatedSubscriptionVariables = Exact<{
  input: UserPagePermissionsBySpaceIdInput;
}>;


export type UserPagePermissionsBySpaceIdUpdatedSubscription = { __typename?: 'Subscription', userPagePermissionsBySpaceId: Array<{ __typename?: 'UserPagePermission', userId: string, pageId: string, spaceId: string, permission: PagePermission }> };

export type UserSharedPagesUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserSharedPagesUpdatedSubscription = { __typename?: 'Subscription', userSharedPages: Array<{ __typename?: 'SharedPageInfo', title: string, permission: PagePermission, sharedBy: string, page: { __typename?: 'SharedPage', id: string, spaceId: string, isPrivateInSpace: boolean, isPublic: boolean, createdAt: any, updatedAt: any }, icon: { __typename?: 'PageIcon', type: string, colons: string } | null }> | null };

export const SubscriptionFragmentFragmentDoc = gql`
    fragment SubscriptionFragment on SpaceSubscription {
  id
  subscriptionId
  status
  canceled
  spaceId
  customerId
  currentPeriodEnd
  currentPeriodStart
  planId
  priceId
  plan {
    id
    featureSet
  }
  price {
    id
    amount
    amountDecimal
    currency
    stripeId
    lookupKey
    interval
    status
  }
}
    `;
export const SpaceFragmentFragmentDoc = gql`
    fragment SpaceFragment on Space {
  id
  title
  urlKey
  createdAt
  isPublic
  isCopyWorkspaceEnabled
  isEmbeddingEnabled
  color
  owner
  useCases
  activeSubscription {
    ...SubscriptionFragment
  }
  subscriptions {
    ...SubscriptionFragment
  }
  access {
    write
  }
  permissions {
    editors {
      enabled
      limit
    }
    guests {
      limit
    }
    tasks {
      enabled
    }
    viewers {
      enabled
    }
    fileUpload {
      limitFile
    }
    sagaAi {
      enabled
      limit
      model
    }
  }
}
    ${SubscriptionFragmentFragmentDoc}`;
export const MemberFragmentFragmentDoc = gql`
    fragment MemberFragment on Member {
  id
  spaceId
  firstName
  lastName
  userEmail
  role
}
    `;
export const SpaceWithMembersFragmentDoc = gql`
    fragment SpaceWithMembers on Space {
  ...SpaceFragment
  members {
    ...MemberFragment
  }
}
    ${SpaceFragmentFragmentDoc}
${MemberFragmentFragmentDoc}`;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  id
  data {
    email
    firstName
    lastName
    agreedToTerms
    agreedToTermsDate
    optInTracking
    language
    role
  }
  createdAt
  updatedAt
}
    `;
export const CustomAiPromptsFragmentDoc = gql`
    fragment CustomAIPrompts on CustomAIPrompt {
  id
  title
  prompt
  position
  type
}
    `;
export const ExtendedSettingsFragmentDoc = gql`
    fragment ExtendedSettings on ExtendedSettings {
  pagesColumnsOrder
  sharedPagesColumnsOrder
  tasksColumnsOrder
  collectionsColumnsOrder
  collectionPropertiesOrder {
    collectionId
    tagViewProperties
    folderViewProperties
  }
}
    `;
export const UserSettingsFragmentDoc = gql`
    fragment UserSettings on UserSettings {
  spaceSorting
  showInlinePageLinkIcons
  weekStartOnMonday
  customAIPrompts {
    ...CustomAIPrompts
  }
  hiddenDefaultPrompts
  interfaceFont
  editorFont
  extendedSettings {
    ...ExtendedSettings
  }
}
    ${CustomAiPromptsFragmentDoc}
${ExtendedSettingsFragmentDoc}`;
export const PublicMemberFragmentDoc = gql`
    fragment PublicMember on Member {
  id
  spaceId
  firstName
  lastName
}
    `;
export const InviteFragmentFragmentDoc = gql`
    fragment InviteFragment on Invite {
  id
  userEmail
  role
}
    `;
export const InviteMetaDataFragmentFragmentDoc = gql`
    fragment InviteMetaDataFragment on InviteMetaData {
  inviteId
  workspaceTitle
  workspaceOwnerEmail
  workspaceMembersCount
  userEmail
}
    `;
export const PageInviteMetaFragmentFragmentDoc = gql`
    fragment PageInviteMetaFragment on PageInviteMeta {
  id
  userEmail
  inviterEmail
  title
  role
}
    `;
export const PageInviteFragmentFragmentDoc = gql`
    fragment PageInviteFragment on PageInvite {
  id
  userEmail
  role
}
    `;
export const PageIconFragmentFragmentDoc = gql`
    fragment PageIconFragment on PageIcon {
  type
  colons
}
    `;
export const PageFragmentFragmentDoc = gql`
    fragment PageFragment on Page {
  id
  title
  icon {
    ...PageIconFragment
  }
  collections
  aliases
  archivedAt
  isTemplate
  isPublicDuplicatable
  settings {
    fullWidth
  }
  spaceId
  staticBlocks
}
    ${PageIconFragmentFragmentDoc}`;
export const PageAndPermissionFragmentFragmentDoc = gql`
    fragment PageAndPermissionFragment on PageAndPermission {
  page {
    ...PageFragment
  }
  permission
}
    ${PageFragmentFragmentDoc}`;
export const SharedPageFragmentFragmentDoc = gql`
    fragment SharedPageFragment on SharedPage {
  id
  spaceId
  isPrivateInSpace
  isPublic
  createdAt
  updatedAt
}
    `;
export const SharedPageInfoFragmentFragmentDoc = gql`
    fragment SharedPageInfoFragment on SharedPageInfo {
  page {
    ...SharedPageFragment
  }
  title
  icon {
    ...PageIconFragment
  }
  permission
  sharedBy
}
    ${SharedPageFragmentFragmentDoc}
${PageIconFragmentFragmentDoc}`;
export const AiChatMessageFragmentFragmentDoc = gql`
    fragment AIChatMessageFragment on AIChatMessage {
  content
  role
  tool_calls
  tool_call_id
  createdAt
}
    `;
export const AiChatThreadFragmentFragmentDoc = gql`
    fragment AIChatThreadFragment on AIChatThread {
  id
  spaceId
  userId
  messages {
    ...AIChatMessageFragment
  }
}
    ${AiChatMessageFragmentFragmentDoc}`;
export const CollectionFragmentFragmentDoc = gql`
    fragment CollectionFragment on Collection {
  id
  title
  updatedAt
}
    `;
export const GoogleDriveFileFragmentDoc = gql`
    fragment GoogleDriveFile on GoogleDriveFile {
  id
  name
  webViewLink
  iconLink
  thumbnailLink
  modifiedTime
  mimeType
  owners {
    displayName
  }
}
    `;
export const LinearIssueFragmentDoc = gql`
    fragment LinearIssue on LinearIssue {
  id
  identifier
  title
  url
  description
  updatedAt
  priorityLabel
  priority
  state {
    name
    color
    type
  }
  assignee {
    name
  }
}
    `;
export const LinearTeamFragmentDoc = gql`
    fragment LinearTeam on LinearTeam {
  id
  name
}
    `;
export const MentionNotificationFragmentDoc = gql`
    fragment MentionNotification on MentionNotification {
  id
  spaceTitle
  spaceColor
  pageTitle
  pageId
  blockId
  spaceId
  spaceUrlKey
  userId
  readAt
  createdAt
  username
  mentionBlockUrl
}
    `;
export const TaskMentionNotificationFragmentDoc = gql`
    fragment TaskMentionNotification on TaskMentionNotification {
  id
  spaceTitle
  spaceColor
  taskTitle
  taskId
  blockId
  spaceId
  spaceUrlKey
  userId
  readAt
  createdAt
  username
  mentionBlockUrl
}
    `;
export const TaskAssignmentNotificationFragmentDoc = gql`
    fragment TaskAssignmentNotification on TaskAssignmentNotification {
  id
  spaceTitle
  spaceColor
  taskId
  taskTitle
  taskUrl
  action
  spaceId
  spaceUrlKey
  userId
  readAt
  createdAt
  username
}
    `;
export const PageInviteNotificationFragmentDoc = gql`
    fragment PageInviteNotification on PageInviteNotification {
  id
  spaceTitle
  spaceColor
  pageTitle
  pageId
  readAt
  createdAt
  username
  userId
  inviteId
}
    `;
export const WorkspaceCollaborationNotificationFragmentDoc = gql`
    fragment WorkspaceCollaborationNotification on WorkspaceCollaborationNotification {
  id
  spaceTitle
  spaceColor
  readAt
  createdAt
  spaceId
  spaceUrlKey
  username
  userId
  type
  inviteId
  activeSubscription
}
    `;
export const FullPageInfoFragmentDoc = gql`
    fragment FullPageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
export const TemplateFragmentDoc = gql`
    fragment Template on Template {
  id
  title
  icon
  blocks
  aliases
}
    `;
export const AiEmbeddingFragmentDoc = gql`
    fragment AIEmbedding on AIEmbedding {
  pageId
  fromBlockId
  toBlockId
  distance
}
    `;
export const UserPagePermissionFragmentFragmentDoc = gql`
    fragment UserPagePermissionFragment on UserPagePermission {
  userId
  pageId
  spaceId
  permission
}
    `;
export const PageMemberFragmentFragmentDoc = gql`
    fragment PageMemberFragment on PageMember {
  firstName
  lastName
  userEmail
  userId
  pageId
  permission
}
    `;
export const PageHistorySnapshotFragmentDoc = gql`
    fragment PageHistorySnapshot on PageHistorySnapshot {
  updatedAt
  buffer
  authorEmail
}
    `;
export const NotificationsConnectionDocument = gql`
    query NotificationsConnection($first: Int, $last: Int, $after: String, $before: String) {
  notificationsConnection(
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    pageInfo {
      ...FullPageInfo
    }
    edges {
      cursor
      node {
        __typename
        id
        createdAt
        spaceTitle
        spaceColor
        readAt
        ... on TaskMentionNotification {
          ...TaskMentionNotification
        }
        ... on TaskAssignmentNotification {
          ...TaskAssignmentNotification
        }
        ... on MentionNotification {
          ...MentionNotification
        }
        ... on PageInviteNotification {
          ...PageInviteNotification
        }
        ... on WorkspaceCollaborationNotification {
          ...WorkspaceCollaborationNotification
        }
      }
    }
  }
}
    ${FullPageInfoFragmentDoc}
${TaskMentionNotificationFragmentDoc}
${TaskAssignmentNotificationFragmentDoc}
${MentionNotificationFragmentDoc}
${PageInviteNotificationFragmentDoc}
${WorkspaceCollaborationNotificationFragmentDoc}`;
export const SpacesDocument = gql`
    query Spaces {
  spaces {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export const UserDocument = gql`
    query User {
  currentUser {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export const UserDataDocument = gql`
    query UserData {
  currentUser {
    ...UserFragment
  }
  getCustomToken {
    token
  }
  cannyToken
  spaces {
    ...SpaceWithMembers
  }
  userSettings {
    ...UserSettings
  }
}
    ${UserFragmentFragmentDoc}
${SpaceWithMembersFragmentDoc}
${UserSettingsFragmentDoc}`;
export const UserInvitesDocument = gql`
    query UserInvites {
  userInvites {
    ...InviteMetaDataFragment
  }
}
    ${InviteMetaDataFragmentFragmentDoc}`;
export const SpaceByUrlKeyDocument = gql`
    query SpaceByUrlKey($input: SpaceByUrlKeyInput!) {
  spaceByUrlKey(input: $input) {
    ...SpaceWithMembers
  }
}
    ${SpaceWithMembersFragmentDoc}`;
export const InvitesAndMembersDocument = gql`
    query InvitesAndMembers($urlKey: String!) {
  members(input: {urlKey: $urlKey}) {
    ...MemberFragment
  }
  invites(input: {urlKey: $urlKey}) {
    ...InviteFragment
  }
}
    ${MemberFragmentFragmentDoc}
${InviteFragmentFragmentDoc}`;
export const MembersDocument = gql`
    query Members($input: MembersInput!) {
  members(input: $input) {
    ...PublicMember
  }
}
    ${PublicMemberFragmentDoc}`;
export const InviteMetaDataDocument = gql`
    query InviteMetaData($input: InviteMetaDataInput!) {
  inviteMetaData(input: $input) {
    ...InviteMetaDataFragment
  }
}
    ${InviteMetaDataFragmentFragmentDoc}`;
export const PageDocument = gql`
    query Page($input: PageInput!) {
  page(input: $input) {
    ...PageAndPermissionFragment
  }
}
    ${PageAndPermissionFragmentFragmentDoc}`;
export const SharedPageStatusDocument = gql`
    query SharedPageStatus($input: PageInput!) {
  sharedPageStatus(input: $input) {
    ...SharedPageFragment
  }
}
    ${SharedPageFragmentFragmentDoc}`;
export const AllSharedPagesStatusesByUrlKeyDocument = gql`
    query AllSharedPagesStatusesByUrlKey($input: PagesByUrlKeyInput!) {
  allSharedPagesStatusesByUrlKey(input: $input) {
    ...SharedPageFragment
  }
}
    ${SharedPageFragmentFragmentDoc}`;
export const PagesByUrlKeyDocument = gql`
    query PagesByUrlKey($input: PagesByUrlKeyInput!) {
  pagesByUrlKey(input: $input) {
    ...PageFragment
  }
}
    ${PageFragmentFragmentDoc}`;
export const CollectionsByUrlKeyDocument = gql`
    query CollectionsByUrlKey($input: CollectionsByUrlKeyInput!) {
  collectionsByUrlKey(input: $input) {
    ...CollectionFragment
  }
}
    ${CollectionFragmentFragmentDoc}`;
export const GetCustomTokenDocument = gql`
    query GetCustomToken {
  getCustomToken {
    token
  }
}
    `;
export const SearchIntegrationsDocument = gql`
    query SearchIntegrations($input: IntegrationSearchInput!) {
  searchIntegrations(input: $input) {
    googleDriveFiles {
      ...GoogleDriveFile
    }
    linearIssues {
      ...LinearIssue
    }
  }
}
    ${GoogleDriveFileFragmentDoc}
${LinearIssueFragmentDoc}`;
export const LinearIssueDocument = gql`
    query LinearIssue($input: LinearIssueInput!) {
  linearIssue(input: $input) {
    ...LinearIssue
  }
}
    ${LinearIssueFragmentDoc}`;
export const GoogleDriveDocumentDocument = gql`
    query GoogleDriveDocument($input: GoogleDriveFileInput!) {
  googleDriveDocument(input: $input) {
    ...GoogleDriveFile
  }
}
    ${GoogleDriveFileFragmentDoc}`;
export const UserIntegrationsDocument = gql`
    query UserIntegrations {
  userIntegrations {
    id
    type
    isActive
  }
}
    `;
export const UnreadNotificationsCounterDocument = gql`
    query UnreadNotificationsCounter {
  unreadNotificationsCounter
}
    `;
export const TemplatesDocument = gql`
    query Templates {
  templates {
    ...Template
  }
}
    ${TemplateFragmentDoc}`;
export const LinearTeamsDocument = gql`
    query LinearTeams {
  linearTeams {
    ...LinearTeam
  }
}
    ${LinearTeamFragmentDoc}`;
export const SubscriptionPlansDocument = gql`
    query SubscriptionPlans {
  subscriptionPlans {
    id
    stripeId
    featureSet
    price {
      id
      amount
      amountDecimal
      currency
      stripeId
      lookupKey
      interval
      status
    }
  }
}
    `;
export const InvoicesDocument = gql`
    query Invoices($input: InvoicesInput!) {
  invoices(input: $input) {
    id
    subscriptionId
    created
    paid
    total
    pdfUrl
  }
}
    `;
export const SubscriptionUpcomingDocument = gql`
    query SubscriptionUpcoming($input: SubscriptionUpcomingInput!) {
  subscriptionUpcoming(input: $input) {
    periodStart
    periodEnd
    paid
    total
    created
  }
}
    `;
export const SpaceEmbeddingsDocument = gql`
    query SpaceEmbeddings($input: EmbeddingSearchInput!) {
  spaceEmbeddings(input: $input) {
    ...AIEmbedding
  }
}
    ${AiEmbeddingFragmentDoc}`;
export const AdminUserListDocument = gql`
    query AdminUserList($input: AdminUserListInput!) {
  adminUserList(input: $input) {
    users {
      id
      email
      names
      role
      createdAt
      updatedAt
    }
    pageInfo {
      ...FullPageInfo
    }
  }
}
    ${FullPageInfoFragmentDoc}`;
export const AdminUserListSharedCountDocument = gql`
    query AdminUserListSharedCount($input: AdminUserListSharedCountInput!) {
  adminUserListSharedCount(input: $input) {
    publicPagesCount
    publicSpacesCount
  }
}
    `;
export const AdminSpaceListDocument = gql`
    query AdminSpaceList($input: AdminSpaceListInput!) {
  adminSpaceList(input: $input) {
    id
    title
    urlKey
    createdAt
    ownerIds
    usedSpaceTokens
    activeSubscription {
      id
      status
      canceled
      customerId
      currentPeriodEnd
      currentPeriodStart
      plan {
        id
      }
    }
  }
}
    `;
export const SpacePermissionsDocument = gql`
    query SpacePermissions($input: SpaceByUrlKeyInput!) {
  spacePermissions(input: $input) {
    sagaAiStatus
  }
}
    `;
export const BillingPortalDocument = gql`
    query BillingPortal($input: BillingPortalInput!) {
  billingPortal(input: $input)
}
    `;
export const UserPagePermissionsBySpaceIdDocument = gql`
    query UserPagePermissionsBySpaceId($input: UserPagePermissionsBySpaceIdInput!) {
  userPagePermissionsBySpaceId(input: $input) {
    ...UserPagePermissionFragment
  }
}
    ${UserPagePermissionFragmentFragmentDoc}`;
export const PageInvitesAndMembersDocument = gql`
    query PageInvitesAndMembers($pageId: String!, $spaceId: String!) {
  pageMembers(input: {spaceId: $spaceId, pageId: $pageId}) {
    ...PageMemberFragment
  }
  pageInvites(input: {spaceId: $spaceId, pageId: $pageId}) {
    ...PageInviteFragment
  }
}
    ${PageMemberFragmentFragmentDoc}
${PageInviteFragmentFragmentDoc}`;
export const PageInviteMetaDataDocument = gql`
    query PageInviteMetaData($input: PageInviteMetaInput!) {
  pageInviteMetaData(input: $input) {
    ...PageInviteMetaFragment
  }
}
    ${PageInviteMetaFragmentFragmentDoc}`;
export const UserPageInvitesDocument = gql`
    query UserPageInvites {
  userPageInvites {
    ...PageInviteMetaFragment
  }
}
    ${PageInviteMetaFragmentFragmentDoc}`;
export const UserSharedPagesDocument = gql`
    query UserSharedPages {
  userSharedPages {
    ...SharedPageInfoFragment
  }
}
    ${SharedPageInfoFragmentFragmentDoc}`;
export const ChatThreadsDocument = gql`
    query ChatThreads($input: ChatThreadsInput!) {
  chatThreads(input: $input) {
    ...AIChatThreadFragment
  }
}
    ${AiChatThreadFragmentFragmentDoc}`;
export const PageHistoryDocument = gql`
    query PageHistory($input: PageHistoryInput!) {
  pageHistory(input: $input) {
    ...PageHistorySnapshot
  }
}
    ${PageHistorySnapshotFragmentDoc}`;
export const AdminUserDetailsDocument = gql`
    mutation AdminUserDetails($input: AdminUserDetailsInput!) {
  adminUserDetails(input: $input) {
    id
    email
    firstName
    lastName
    role
    createdAt
    updatedAt
    membership {
      spaceId
      spaceName
      publicPages {
        ...SharedPageFragment
      }
      spaceDeletable
      role
    }
    integrations {
      id
      type
      isActive
    }
  }
}
    ${SharedPageFragmentFragmentDoc}`;
export const AdminUserDeleteDocument = gql`
    mutation AdminUserDelete($input: AdminUsersDeleteInput!) {
  adminUserDelete(input: $input) {
    userId
    status
  }
}
    `;
export const UpdateUserNameDocument = gql`
    mutation UpdateUserName($input: UpdateUserNameInput!) {
  updateUserName(input: $input) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export const UpdateUserLanguageDocument = gql`
    mutation updateUserLanguage($input: UpdateUserLanguageInput!) {
  updateUserLanguage(input: $input) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export const SignupDocument = gql`
    mutation Signup($input: SignupInput!) {
  signup(input: $input) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export const CreateSpaceDocument = gql`
    mutation CreateSpace($input: CreateSpaceInput!) {
  createSpace(input: $input) {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export const CreatePageDocument = gql`
    mutation CreatePage($input: CreatePageInput!) {
  createPage(input: $input) {
    ...PageFragment
  }
}
    ${PageFragmentFragmentDoc}`;
export const DeleteSpaceDocument = gql`
    mutation DeleteSpace($input: DeleteSpaceInput!) {
  deleteSpace(input: $input) {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export const CopyWorkspaceDocument = gql`
    mutation CopyWorkspace($input: CopyWorkspaceInput!) {
  copyWorkspace(input: $input) {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export const UpdateSpaceSortingDocument = gql`
    mutation UpdateSpaceSorting($input: UpdateSpaceSortingInput!) {
  updateSpaceSorting(input: $input) {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export const UpdateUserSettingsDocument = gql`
    mutation UpdateUserSettings($input: UpdateUserSettingsInput!) {
  updateUserSettings(input: $input) {
    ...UserSettings
  }
}
    ${UserSettingsFragmentDoc}`;
export const UpdateAiPromptsDocument = gql`
    mutation UpdateAIPrompts($input: [UpdateAIPromptsInput!]!) {
  updateAIPrompts(input: $input) {
    ...CustomAIPrompts
  }
}
    ${CustomAiPromptsFragmentDoc}`;
export const AddAiPromptDocument = gql`
    mutation AddAIPrompt($input: AddAIPromptInput!) {
  addAIPrompt(input: $input) {
    ...CustomAIPrompts
  }
}
    ${CustomAiPromptsFragmentDoc}`;
export const RemoveAiPromptDocument = gql`
    mutation RemoveAIPrompt($input: RemoveAIPromptInput!) {
  removeAIPrompt(input: $input)
}
    `;
export const InviteMembersDocument = gql`
    mutation InviteMembers($input: InviteMembersInput!) {
  inviteMembers(input: $input) {
    ...InviteFragment
  }
}
    ${InviteFragmentFragmentDoc}`;
export const RevokeInviteDocument = gql`
    mutation RevokeInvite($input: RevokeInviteInput!) {
  revokeInvite(input: $input) {
    ...InviteFragment
  }
}
    ${InviteFragmentFragmentDoc}`;
export const AcceptInvitationDocument = gql`
    mutation AcceptInvitation($input: AcceptInvitationInput!) {
  acceptInvitation(input: $input) {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export const RemoveMemberDocument = gql`
    mutation RemoveMember($input: RemoveMemberInput!) {
  removeMember(input: $input)
}
    `;
export const UpdateMemberRoleDocument = gql`
    mutation UpdateMemberRole($input: UpdateMemberRoleInput!) {
  updateMemberRole(input: $input) {
    ...MemberFragment
  }
}
    ${MemberFragmentFragmentDoc}`;
export const LeaveSpaceDocument = gql`
    mutation LeaveSpace($input: LeaveSpaceInput!) {
  leaveSpace(input: $input) {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export const UpdateSpaceMetadataDocument = gql`
    mutation updateSpaceMetadata($input: UpdateSpaceMetadataInput!) {
  updateSpaceMetadata(input: $input) {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export const UpdateSpacePublicMetadataDocument = gql`
    mutation updateSpacePublicMetadata($input: UpdateSpacePublicMetadataInput!) {
  updateSpacePublicMetadata(input: $input) {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export const UpdateSpaceUseCasesDocument = gql`
    mutation UpdateSpaceUseCases($input: UpdateSpaceUseCasesInput!) {
  updateSpaceUseCases(input: $input) {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export const RequestSignInLinkDocument = gql`
    mutation RequestSignInLink($input: RequestSignInLinkInput!) {
  requestSignInLink(input: $input)
}
    `;
export const AddBlocksDocument = gql`
    mutation AddBlocks($input: AddBlocksInput!) {
  addBlocks(input: $input)
}
    `;
export const SendTaskMentionNotificationDocument = gql`
    mutation SendTaskMentionNotification($input: SendTaskMentionNotificationInput!) {
  sendTaskMentionNotification(input: $input)
}
    `;
export const SendTaskAssignmentNotificationDocument = gql`
    mutation SendTaskAssignmentNotification($input: SendTaskAssignmentNotificationInput!) {
  sendTaskAssignmentNotification(input: $input)
}
    `;
export const SendNotificationDocument = gql`
    mutation SendNotification($input: SendNotificationInput!) {
  sendNotification(input: $input)
}
    `;
export const RemoveUserIntegrationDocument = gql`
    mutation removeUserIntegration($input: RemoveUserIntegrationInput!) {
  removeUserIntegration(input: $input)
}
    `;
export const MarkNotificationsAsReadDocument = gql`
    mutation MarkNotificationsAsRead($input: MarkNotificationsAsReadInput!) {
  markNotificationsAsRead(input: $input) {
    __typename
    id
    readAt
  }
}
    `;
export const SharePageDocument = gql`
    mutation SharePage($input: SharePageInput!) {
  sharePage(input: $input) {
    id
  }
}
    `;
export const RemoveSharedPageDocument = gql`
    mutation RemoveSharedPage($input: RemoveSharedPageInput!) {
  removeSharedPage(input: $input)
}
    `;
export const InvitePageMembersDocument = gql`
    mutation InvitePageMembers($input: InvitePageMembersInput!) {
  invitePageMembers(input: $input) {
    ...PageInviteFragment
  }
}
    ${PageInviteFragmentFragmentDoc}`;
export const RevokePageInviteDocument = gql`
    mutation RevokePageInvite($input: RevokePageInviteInput!) {
  revokePageInvite(input: $input) {
    ...PageInviteFragment
  }
}
    ${PageInviteFragmentFragmentDoc}`;
export const AcceptPageInvitationDocument = gql`
    mutation AcceptPageInvitation($input: AcceptPageInvitationInput!) {
  acceptPageInvitation(input: $input) {
    ...SharedPageFragment
  }
}
    ${SharedPageFragmentFragmentDoc}`;
export const LinearIssueCreateDocument = gql`
    mutation LinearIssueCreate($input: LinearIssueCreateInput!) {
  linearIssueCreate(input: $input) {
    ...LinearIssue
  }
}
    ${LinearIssueFragmentDoc}`;
export const LinearIssueDeleteDocument = gql`
    mutation LinearIssueDelete($input: LinearIssueDeleteInput!) {
  linearIssueDelete(input: $input)
}
    `;
export const CreateSubscriptionSessionDocument = gql`
    mutation CreateSubscriptionSession($input: CreateSubscriptionSessionInput!) {
  createSubscriptionSession(input: $input) {
    session
  }
}
    `;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($input: CreateSubscriptionInput!) {
  createSubscription(input: $input) {
    space {
      ...SpaceFragment
      members {
        ...MemberFragment
      }
    }
  }
}
    ${SpaceFragmentFragmentDoc}
${MemberFragmentFragmentDoc}`;
export const CancelSubscriptionDocument = gql`
    mutation CancelSubscription($input: CancelSubscriptionInput!) {
  cancelSubscription(input: $input) {
    ...SubscriptionFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}`;
export const ChangeSubscriptionDocument = gql`
    mutation ChangeSubscription($input: ChangeSubscriptionInput!) {
  changeSubscription(input: $input) {
    ...SubscriptionFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}`;
export const DeleteAssetDocument = gql`
    mutation DeleteAsset($input: DeleteAssetInput!) {
  deleteAsset(input: $input)
}
    `;
export const DuplicatePageAssetsDocument = gql`
    mutation DuplicatePageAssets($input: DuplicatePageAssetsInput!) {
  duplicatePageAssets(input: $input)
}
    `;
export const UpdateUserPagePermissionDocument = gql`
    mutation UpdateUserPagePermission($input: UpdateUserPagePermissionInput!) {
  updateUserPagePermission(input: $input) {
    ...PageMemberFragment
  }
}
    ${PageMemberFragmentFragmentDoc}`;
export const UpdatePageSharedToSpaceDocument = gql`
    mutation UpdatePageSharedToSpace($input: UpdatePageSharedToSpaceInput!) {
  updatePageSharedToSpace(input: $input) {
    ...SharedPageFragment
  }
}
    ${SharedPageFragmentFragmentDoc}`;
export const HideAiThreadDocument = gql`
    mutation HideAIThread($input: HideAIThreadInput!) {
  hideAIThread(input: $input)
}
    `;
export const UnreadNotificationsCounterUpdatedDocument = gql`
    subscription UnreadNotificationsCounterUpdated {
  unreadNotificationsCounterUpdated
}
    `;
export const PermissionsUpdatedDocument = gql`
    subscription PermissionsUpdated($input: PermissionsUpdatedInput!) {
  permissionsUpdated(input: $input) {
    sagaAiStatus
  }
}
    `;
export const UserPagePermissionsBySpaceIdUpdatedDocument = gql`
    subscription userPagePermissionsBySpaceIdUpdated($input: UserPagePermissionsBySpaceIdInput!) {
  userPagePermissionsBySpaceId(input: $input) {
    ...UserPagePermissionFragment
  }
}
    ${UserPagePermissionFragmentFragmentDoc}`;
export const UserSharedPagesUpdatedDocument = gql`
    subscription UserSharedPagesUpdated {
  userSharedPages {
    ...SharedPageInfoFragment
  }
}
    ${SharedPageInfoFragmentFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    NotificationsConnection(variables?: NotificationsConnectionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NotificationsConnectionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NotificationsConnectionQuery>(NotificationsConnectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'NotificationsConnection', 'query', variables);
    },
    Spaces(variables?: SpacesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpacesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpacesQuery>(SpacesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Spaces', 'query', variables);
    },
    User(variables?: UserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserQuery>(UserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'User', 'query', variables);
    },
    UserData(variables?: UserDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserDataQuery>(UserDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserData', 'query', variables);
    },
    UserInvites(variables?: UserInvitesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserInvitesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserInvitesQuery>(UserInvitesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserInvites', 'query', variables);
    },
    SpaceByUrlKey(variables: SpaceByUrlKeyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpaceByUrlKeyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpaceByUrlKeyQuery>(SpaceByUrlKeyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SpaceByUrlKey', 'query', variables);
    },
    InvitesAndMembers(variables: InvitesAndMembersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvitesAndMembersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvitesAndMembersQuery>(InvitesAndMembersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'InvitesAndMembers', 'query', variables);
    },
    Members(variables: MembersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MembersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MembersQuery>(MembersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Members', 'query', variables);
    },
    InviteMetaData(variables: InviteMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InviteMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InviteMetaDataQuery>(InviteMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'InviteMetaData', 'query', variables);
    },
    Page(variables: PageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PageQuery>(PageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Page', 'query', variables);
    },
    SharedPageStatus(variables: SharedPageStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SharedPageStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SharedPageStatusQuery>(SharedPageStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SharedPageStatus', 'query', variables);
    },
    AllSharedPagesStatusesByUrlKey(variables: AllSharedPagesStatusesByUrlKeyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AllSharedPagesStatusesByUrlKeyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllSharedPagesStatusesByUrlKeyQuery>(AllSharedPagesStatusesByUrlKeyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AllSharedPagesStatusesByUrlKey', 'query', variables);
    },
    PagesByUrlKey(variables: PagesByUrlKeyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PagesByUrlKeyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PagesByUrlKeyQuery>(PagesByUrlKeyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PagesByUrlKey', 'query', variables);
    },
    CollectionsByUrlKey(variables: CollectionsByUrlKeyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CollectionsByUrlKeyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CollectionsByUrlKeyQuery>(CollectionsByUrlKeyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CollectionsByUrlKey', 'query', variables);
    },
    GetCustomToken(variables?: GetCustomTokenQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCustomTokenQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCustomTokenQuery>(GetCustomTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetCustomToken', 'query', variables);
    },
    SearchIntegrations(variables: SearchIntegrationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchIntegrationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchIntegrationsQuery>(SearchIntegrationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SearchIntegrations', 'query', variables);
    },
    LinearIssue(variables: LinearIssueQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LinearIssueQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LinearIssueQuery>(LinearIssueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LinearIssue', 'query', variables);
    },
    GoogleDriveDocument(variables: GoogleDriveDocumentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GoogleDriveDocumentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GoogleDriveDocumentQuery>(GoogleDriveDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GoogleDriveDocument', 'query', variables);
    },
    UserIntegrations(variables?: UserIntegrationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserIntegrationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserIntegrationsQuery>(UserIntegrationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserIntegrations', 'query', variables);
    },
    UnreadNotificationsCounter(variables?: UnreadNotificationsCounterQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnreadNotificationsCounterQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnreadNotificationsCounterQuery>(UnreadNotificationsCounterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UnreadNotificationsCounter', 'query', variables);
    },
    Templates(variables?: TemplatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TemplatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TemplatesQuery>(TemplatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Templates', 'query', variables);
    },
    LinearTeams(variables?: LinearTeamsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LinearTeamsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LinearTeamsQuery>(LinearTeamsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LinearTeams', 'query', variables);
    },
    SubscriptionPlans(variables?: SubscriptionPlansQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SubscriptionPlansQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubscriptionPlansQuery>(SubscriptionPlansDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SubscriptionPlans', 'query', variables);
    },
    Invoices(variables: InvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesQuery>(InvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Invoices', 'query', variables);
    },
    SubscriptionUpcoming(variables: SubscriptionUpcomingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SubscriptionUpcomingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubscriptionUpcomingQuery>(SubscriptionUpcomingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SubscriptionUpcoming', 'query', variables);
    },
    SpaceEmbeddings(variables: SpaceEmbeddingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpaceEmbeddingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpaceEmbeddingsQuery>(SpaceEmbeddingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SpaceEmbeddings', 'query', variables);
    },
    AdminUserList(variables: AdminUserListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUserListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUserListQuery>(AdminUserListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUserList', 'query', variables);
    },
    AdminUserListSharedCount(variables: AdminUserListSharedCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUserListSharedCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUserListSharedCountQuery>(AdminUserListSharedCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUserListSharedCount', 'query', variables);
    },
    AdminSpaceList(variables: AdminSpaceListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminSpaceListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminSpaceListQuery>(AdminSpaceListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminSpaceList', 'query', variables);
    },
    SpacePermissions(variables: SpacePermissionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpacePermissionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpacePermissionsQuery>(SpacePermissionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SpacePermissions', 'query', variables);
    },
    BillingPortal(variables: BillingPortalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BillingPortalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BillingPortalQuery>(BillingPortalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BillingPortal', 'query', variables);
    },
    UserPagePermissionsBySpaceId(variables: UserPagePermissionsBySpaceIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserPagePermissionsBySpaceIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserPagePermissionsBySpaceIdQuery>(UserPagePermissionsBySpaceIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserPagePermissionsBySpaceId', 'query', variables);
    },
    PageInvitesAndMembers(variables: PageInvitesAndMembersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PageInvitesAndMembersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PageInvitesAndMembersQuery>(PageInvitesAndMembersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PageInvitesAndMembers', 'query', variables);
    },
    PageInviteMetaData(variables: PageInviteMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PageInviteMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PageInviteMetaDataQuery>(PageInviteMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PageInviteMetaData', 'query', variables);
    },
    UserPageInvites(variables?: UserPageInvitesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserPageInvitesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserPageInvitesQuery>(UserPageInvitesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserPageInvites', 'query', variables);
    },
    UserSharedPages(variables?: UserSharedPagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserSharedPagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserSharedPagesQuery>(UserSharedPagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserSharedPages', 'query', variables);
    },
    ChatThreads(variables: ChatThreadsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChatThreadsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChatThreadsQuery>(ChatThreadsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ChatThreads', 'query', variables);
    },
    PageHistory(variables: PageHistoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PageHistoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PageHistoryQuery>(PageHistoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PageHistory', 'query', variables);
    },
    AdminUserDetails(variables: AdminUserDetailsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUserDetailsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUserDetailsMutation>(AdminUserDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUserDetails', 'mutation', variables);
    },
    AdminUserDelete(variables: AdminUserDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUserDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUserDeleteMutation>(AdminUserDeleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUserDelete', 'mutation', variables);
    },
    UpdateUserName(variables: UpdateUserNameMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserNameMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserNameMutation>(UpdateUserNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateUserName', 'mutation', variables);
    },
    updateUserLanguage(variables: UpdateUserLanguageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserLanguageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserLanguageMutation>(UpdateUserLanguageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserLanguage', 'mutation', variables);
    },
    Signup(variables: SignupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SignupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignupMutation>(SignupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Signup', 'mutation', variables);
    },
    CreateSpace(variables: CreateSpaceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSpaceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSpaceMutation>(CreateSpaceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSpace', 'mutation', variables);
    },
    CreatePage(variables: CreatePageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePageMutation>(CreatePageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreatePage', 'mutation', variables);
    },
    DeleteSpace(variables: DeleteSpaceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteSpaceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSpaceMutation>(DeleteSpaceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteSpace', 'mutation', variables);
    },
    CopyWorkspace(variables: CopyWorkspaceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CopyWorkspaceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CopyWorkspaceMutation>(CopyWorkspaceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CopyWorkspace', 'mutation', variables);
    },
    UpdateSpaceSorting(variables: UpdateSpaceSortingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSpaceSortingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSpaceSortingMutation>(UpdateSpaceSortingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateSpaceSorting', 'mutation', variables);
    },
    UpdateUserSettings(variables: UpdateUserSettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserSettingsMutation>(UpdateUserSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateUserSettings', 'mutation', variables);
    },
    UpdateAIPrompts(variables: UpdateAiPromptsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAiPromptsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAiPromptsMutation>(UpdateAiPromptsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateAIPrompts', 'mutation', variables);
    },
    AddAIPrompt(variables: AddAiPromptMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddAiPromptMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddAiPromptMutation>(AddAiPromptDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddAIPrompt', 'mutation', variables);
    },
    RemoveAIPrompt(variables: RemoveAiPromptMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveAiPromptMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveAiPromptMutation>(RemoveAiPromptDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveAIPrompt', 'mutation', variables);
    },
    InviteMembers(variables: InviteMembersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InviteMembersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InviteMembersMutation>(InviteMembersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'InviteMembers', 'mutation', variables);
    },
    RevokeInvite(variables: RevokeInviteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RevokeInviteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RevokeInviteMutation>(RevokeInviteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RevokeInvite', 'mutation', variables);
    },
    AcceptInvitation(variables: AcceptInvitationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AcceptInvitationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcceptInvitationMutation>(AcceptInvitationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AcceptInvitation', 'mutation', variables);
    },
    RemoveMember(variables: RemoveMemberMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveMemberMutation>(RemoveMemberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveMember', 'mutation', variables);
    },
    UpdateMemberRole(variables: UpdateMemberRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateMemberRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMemberRoleMutation>(UpdateMemberRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateMemberRole', 'mutation', variables);
    },
    LeaveSpace(variables: LeaveSpaceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LeaveSpaceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LeaveSpaceMutation>(LeaveSpaceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LeaveSpace', 'mutation', variables);
    },
    updateSpaceMetadata(variables: UpdateSpaceMetadataMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSpaceMetadataMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSpaceMetadataMutation>(UpdateSpaceMetadataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSpaceMetadata', 'mutation', variables);
    },
    updateSpacePublicMetadata(variables: UpdateSpacePublicMetadataMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSpacePublicMetadataMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSpacePublicMetadataMutation>(UpdateSpacePublicMetadataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSpacePublicMetadata', 'mutation', variables);
    },
    UpdateSpaceUseCases(variables: UpdateSpaceUseCasesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSpaceUseCasesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSpaceUseCasesMutation>(UpdateSpaceUseCasesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateSpaceUseCases', 'mutation', variables);
    },
    RequestSignInLink(variables: RequestSignInLinkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RequestSignInLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestSignInLinkMutation>(RequestSignInLinkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RequestSignInLink', 'mutation', variables);
    },
    AddBlocks(variables: AddBlocksMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddBlocksMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddBlocksMutation>(AddBlocksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddBlocks', 'mutation', variables);
    },
    SendTaskMentionNotification(variables: SendTaskMentionNotificationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendTaskMentionNotificationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendTaskMentionNotificationMutation>(SendTaskMentionNotificationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SendTaskMentionNotification', 'mutation', variables);
    },
    SendTaskAssignmentNotification(variables: SendTaskAssignmentNotificationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendTaskAssignmentNotificationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendTaskAssignmentNotificationMutation>(SendTaskAssignmentNotificationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SendTaskAssignmentNotification', 'mutation', variables);
    },
    SendNotification(variables: SendNotificationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendNotificationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendNotificationMutation>(SendNotificationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SendNotification', 'mutation', variables);
    },
    removeUserIntegration(variables: RemoveUserIntegrationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveUserIntegrationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveUserIntegrationMutation>(RemoveUserIntegrationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeUserIntegration', 'mutation', variables);
    },
    MarkNotificationsAsRead(variables: MarkNotificationsAsReadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkNotificationsAsReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkNotificationsAsReadMutation>(MarkNotificationsAsReadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MarkNotificationsAsRead', 'mutation', variables);
    },
    SharePage(variables: SharePageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SharePageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SharePageMutation>(SharePageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SharePage', 'mutation', variables);
    },
    RemoveSharedPage(variables: RemoveSharedPageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveSharedPageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveSharedPageMutation>(RemoveSharedPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveSharedPage', 'mutation', variables);
    },
    InvitePageMembers(variables: InvitePageMembersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvitePageMembersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvitePageMembersMutation>(InvitePageMembersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'InvitePageMembers', 'mutation', variables);
    },
    RevokePageInvite(variables: RevokePageInviteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RevokePageInviteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RevokePageInviteMutation>(RevokePageInviteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RevokePageInvite', 'mutation', variables);
    },
    AcceptPageInvitation(variables: AcceptPageInvitationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AcceptPageInvitationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcceptPageInvitationMutation>(AcceptPageInvitationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AcceptPageInvitation', 'mutation', variables);
    },
    LinearIssueCreate(variables: LinearIssueCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LinearIssueCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LinearIssueCreateMutation>(LinearIssueCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LinearIssueCreate', 'mutation', variables);
    },
    LinearIssueDelete(variables: LinearIssueDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LinearIssueDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LinearIssueDeleteMutation>(LinearIssueDeleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LinearIssueDelete', 'mutation', variables);
    },
    CreateSubscriptionSession(variables: CreateSubscriptionSessionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSubscriptionSessionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSubscriptionSessionMutation>(CreateSubscriptionSessionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSubscriptionSession', 'mutation', variables);
    },
    CreateSubscription(variables: CreateSubscriptionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSubscriptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSubscriptionMutation>(CreateSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSubscription', 'mutation', variables);
    },
    CancelSubscription(variables: CancelSubscriptionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CancelSubscriptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelSubscriptionMutation>(CancelSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CancelSubscription', 'mutation', variables);
    },
    ChangeSubscription(variables: ChangeSubscriptionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChangeSubscriptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeSubscriptionMutation>(ChangeSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ChangeSubscription', 'mutation', variables);
    },
    DeleteAsset(variables: DeleteAssetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteAssetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteAssetMutation>(DeleteAssetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteAsset', 'mutation', variables);
    },
    DuplicatePageAssets(variables: DuplicatePageAssetsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DuplicatePageAssetsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DuplicatePageAssetsMutation>(DuplicatePageAssetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DuplicatePageAssets', 'mutation', variables);
    },
    UpdateUserPagePermission(variables: UpdateUserPagePermissionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserPagePermissionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserPagePermissionMutation>(UpdateUserPagePermissionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateUserPagePermission', 'mutation', variables);
    },
    UpdatePageSharedToSpace(variables: UpdatePageSharedToSpaceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePageSharedToSpaceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePageSharedToSpaceMutation>(UpdatePageSharedToSpaceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdatePageSharedToSpace', 'mutation', variables);
    },
    HideAIThread(variables: HideAiThreadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<HideAiThreadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<HideAiThreadMutation>(HideAiThreadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'HideAIThread', 'mutation', variables);
    },
    UnreadNotificationsCounterUpdated(variables?: UnreadNotificationsCounterUpdatedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnreadNotificationsCounterUpdatedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnreadNotificationsCounterUpdatedSubscription>(UnreadNotificationsCounterUpdatedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UnreadNotificationsCounterUpdated', 'subscription', variables);
    },
    PermissionsUpdated(variables: PermissionsUpdatedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PermissionsUpdatedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<PermissionsUpdatedSubscription>(PermissionsUpdatedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PermissionsUpdated', 'subscription', variables);
    },
    userPagePermissionsBySpaceIdUpdated(variables: UserPagePermissionsBySpaceIdUpdatedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserPagePermissionsBySpaceIdUpdatedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserPagePermissionsBySpaceIdUpdatedSubscription>(UserPagePermissionsBySpaceIdUpdatedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userPagePermissionsBySpaceIdUpdated', 'subscription', variables);
    },
    UserSharedPagesUpdated(variables?: UserSharedPagesUpdatedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserSharedPagesUpdatedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserSharedPagesUpdatedSubscription>(UserSharedPagesUpdatedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserSharedPagesUpdated', 'subscription', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;